webpackJsonp([1],{

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(79);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(702);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),

/***/ 681:
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f3ef1618.png";

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e7ea4e8.png";

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f0d36523.png";

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7b6765cd.png";

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "9fd0f3f1.png";

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f4091b82.png";

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var React = __webpack_require__(2);
var ReactDOM = __webpack_require__(79);
var PropTypes = __webpack_require__(689);
var createReactClass = __webpack_require__(692);
var isVisibleWithOffset = __webpack_require__(695)

var containmentPropType = PropTypes.any;

if (typeof window !== 'undefined') {
  containmentPropType = PropTypes.instanceOf(window.Element);
}

function throttle (callback, limit) {
    var wait = false;
    return function () {
        if (!wait) {
            wait = true;
            setTimeout(function () {
                callback();
                wait = false;
            }, limit);
        }
    }
}

function debounce(func, wait) {
  var timeout;
  return function() {
    var context = this, args = arguments;
    var later = function() {
      timeout = null;
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

module.exports = createReactClass({
  displayName: 'VisibilitySensor',

  propTypes: {
    onChange: PropTypes.func,
    active: PropTypes.bool,
    partialVisibility: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
    ]),
    delayedCall: PropTypes.bool,
    offset: PropTypes.oneOfType([
      PropTypes.shape({
        top: PropTypes.number,
        left: PropTypes.number,
        bottom: PropTypes.number,
        right: PropTypes.number
      }),
      // deprecated offset property
      PropTypes.shape({
        direction: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
        value: PropTypes.number
      })
    ]),
    scrollCheck: PropTypes.bool,
    scrollDelay: PropTypes.number,
    scrollThrottle: PropTypes.number,
    resizeCheck: PropTypes.bool,
    resizeDelay: PropTypes.number,
    resizeThrottle: PropTypes.number,
    intervalCheck: PropTypes.bool,
    intervalDelay: PropTypes.number,
    containment: containmentPropType,
    children: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
    ]),
    minTopValue: PropTypes.number,
  },

  getDefaultProps: function () {
    return {
      active: true,
      partialVisibility: false,
      minTopValue: 0,
      scrollCheck: false,
      scrollDelay: 250,
      scrollThrottle: -1,
      resizeCheck: false,
      resizeDelay: 250,
      resizeThrottle: -1,
      intervalCheck: true,
      intervalDelay: 100,
      delayedCall: false,
      offset: {},
      containment: null,
      children: React.createElement('span')
    };
  },

  getInitialState: function () {
    return {
      isVisible: null,
      visibilityRect: {}
    };
  },

  componentDidMount: function () {
    this.node = ReactDOM.findDOMNode(this);
    if (this.props.active) {
      this.startWatching();
    }
  },

  componentWillUnmount: function () {
    this.stopWatching();
  },

  componentWillReceiveProps: function (nextProps) {
    if (nextProps.active && !this.props.active) {
      this.setState(this.getInitialState());
      this.startWatching();
    } else if (!nextProps.active) {
      this.stopWatching();
    }
  },

  getContainer: function () {
    return this.props.containment || window;
  },

  addEventListener: function (target, event, delay, throttle) {
    if (!this.debounceCheck) {
      this.debounceCheck = {};
    }

    var timeout;
    var func;

    var later = function () {
      timeout = null;
      this.check();
    }.bind(this);

    if (throttle > -1) {
      func = function () {
        if (!timeout) {
          timeout = setTimeout(later, throttle || 0);
        }
      };
    } else {
      func = function () {
        clearTimeout(timeout);
        timeout = setTimeout(later, delay || 0);
      };
    }

    var info = {
      target: target,
      fn: func,
      getLastTimeout: function () {
        return timeout;
      },
    };

    target.addEventListener(event, info.fn);
    this.debounceCheck[event] = info;
  },

  startWatching: function () {
    if (this.debounceCheck || this.interval) { return; }

    if (this.props.intervalCheck) {
      this.interval = setInterval(this.check, this.props.intervalDelay);
    }

    if (this.props.scrollCheck) {
      this.addEventListener(
        this.getContainer(),
        'scroll',
        this.props.scrollDelay,
        this.props.scrollThrottle
      );
    }

    if (this.props.resizeCheck) {
      this.addEventListener(
        window,
        'resize',
        this.props.resizeDelay,
        this.props.resizeThrottle
      );
    }

    // if dont need delayed call, check on load ( before the first interval fires )
    !this.props.delayedCall && this.check();
  },

  stopWatching: function () {
    if (this.debounceCheck) {
      // clean up event listeners and their debounce callers
      for (var debounceEvent in this.debounceCheck) {
        if (this.debounceCheck.hasOwnProperty(debounceEvent)) {
          var debounceInfo = this.debounceCheck[debounceEvent];

          clearTimeout(debounceInfo.getLastTimeout());
          debounceInfo.target.removeEventListener(
            debounceEvent, debounceInfo.fn
          );

          this.debounceCheck[debounceEvent] = null;
        }
      }
    }
    this.debounceCheck = null;

    if (this.interval) { this.interval = clearInterval(this.interval); }
  },

  /**
   * Check if the element is within the visible viewport
   */
  check: function () {
    var el = this.node;
    var rect;
    var containmentRect;
    // if the component has rendered to null, dont update visibility
    if (!el) {
      return this.state;
    }

    rect = el.getBoundingClientRect();

    if (this.props.containment) {
      var containmentDOMRect = this.props.containment.getBoundingClientRect();
      containmentRect = {
        top: containmentDOMRect.top,
        left: containmentDOMRect.left,
        bottom: containmentDOMRect.bottom,
        right: containmentDOMRect.right,
      }
    } else {
      containmentRect = {
        top: 0,
        left: 0,
        bottom: window.innerHeight || document.documentElement.clientHeight,
        right: window.innerWidth || document.documentElement.clientWidth
      };
    }

    // Check if visibility is wanted via offset?
    var offset = this.props.offset || {};
    var hasValidOffset = typeof offset === 'object';
    if (hasValidOffset) {
      containmentRect.top += offset.top || 0;
      containmentRect.left += offset.left || 0;
      containmentRect.bottom -= offset.bottom || 0;
      containmentRect.right -= offset.right || 0;
    }

    var visibilityRect = {
      top: rect.top >= containmentRect.top,
      left: rect.left >= containmentRect.left,
      bottom: rect.bottom <= containmentRect.bottom,
      right: rect.right <= containmentRect.right
    };

    var isVisible = (
      visibilityRect.top &&
      visibilityRect.left &&
      visibilityRect.bottom &&
      visibilityRect.right
    );

    // check for partial visibility
    if (this.props.partialVisibility) {
      var partialVisible =
          rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top &&
          rect.left <= containmentRect.right && rect.right >= containmentRect.left;

      // account for partial visibility on a single edge
      if (typeof this.props.partialVisibility === 'string') {
        partialVisible = visibilityRect[this.props.partialVisibility]
      }

      // if we have minimum top visibility set by props, lets check, if it meets the passed value
      // so if for instance element is at least 200px in viewport, then show it.
      isVisible = this.props.minTopValue
        ? partialVisible && rect.top <= (containmentRect.bottom - this.props.minTopValue)
        : partialVisible
    }

    // Deprecated options for calculating offset.
    if (typeof offset.direction === 'string' &&
        typeof offset.value === 'number') {
      console.warn('[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }', offset.direction, offset.value)

      isVisible = isVisibleWithOffset(offset, rect, containmentRect);
    }

    var state = this.state;
    // notify the parent when the value changes
    if (this.state.isVisible !== isVisible) {
      state = {
        isVisible: isVisible,
        visibilityRect: visibilityRect
      };
      this.setState(state);
      if (this.props.onChange) this.props.onChange(isVisible, visibilityRect);
    }

    return state;
  },

  render: function () {
    if (this.props.children instanceof Function) {
      return this.props.children({
        isVisible: this.state.isVisible,
        visibilityRect: this.state.visibilityRect,
      });
    }
    return React.Children.only(this.props.children);
  }
});


/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(690)();
}


/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(691);

function emptyFunction() {}

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 692:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(2);
var factory = __webpack_require__(693);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),

/***/ 693:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(111);

var emptyObject = __webpack_require__(694);
var _invariant = __webpack_require__(247);

if (false) {
  var warning = require('fbjs/lib/warning');
}

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),

/***/ 694:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),

/***/ 695:
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value;

  // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.
  switch (offsetDir) {
  case 'top':
    return ((containmentRect.top + offsetVal) < rect.top) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right);

  case 'left':
    return ((containmentRect.left + offsetVal) < rect.left) &&
      (containmentRect.bottom > rect.bottom) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.right > rect.right);

  case 'bottom':
    return ((containmentRect.bottom - offsetVal) > rect.bottom) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.right > rect.right) &&
      (containmentRect.top < rect.top);

  case 'right':
    return ((containmentRect.right - offsetVal) > rect.right) &&
      (containmentRect.left < rect.left) &&
      (containmentRect.top < rect.top) &&
      (containmentRect.bottom > rect.bottom);
  }
}


/***/ }),

/***/ 696:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "32595ba7.png";

/***/ }),

/***/ 697:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "522d151e.png";

/***/ }),

/***/ 698:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "a5238201.png";

/***/ }),

/***/ 699:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "3cbdbb15.png";

/***/ }),

/***/ 700:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4be5d3d5.png";

/***/ }),

/***/ 701:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "bf4d4b2e.png";

/***/ }),

/***/ 702:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(703);

var _json2mq = __webpack_require__(710);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(712);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(677);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(713);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),

/***/ 703:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(79);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(704);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(705);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(77);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(677);

var _track = __webpack_require__(706);

var _dots = __webpack_require__(707);

var _arrows = __webpack_require__(708);

var _resizeObserverPolyfill = __webpack_require__(709);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),

/***/ 704:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),

/***/ 705:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(26)))

/***/ }),

/***/ 706:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(77);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(677);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),

/***/ 707:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(77);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),

/***/ 708:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(77);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(677);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),

/***/ 709:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }

    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;

        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;

                return true;
            }

            return false;
        });

        return result;
    }

    return (function () {
        function anonymous() {
            this.__entries__ = [];
        }

        var prototypeAccessors = { size: { configurable: true } };

        /**
         * @returns {boolean}
         */
        prototypeAccessors.size.get = function () {
            return this.__entries__.length;
        };

        /**
         * @param {*} key
         * @returns {*}
         */
        anonymous.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];

            return entry && entry[1];
        };

        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        anonymous.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);

            if (~index) {
                this.__entries__[index][1] = value;
            } else {
                this.__entries__.push([key, value]);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);

            if (~index) {
                entries.splice(index, 1);
            }
        };

        /**
         * @param {*} key
         * @returns {void}
         */
        anonymous.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };

        /**
         * @returns {void}
         */
        anonymous.prototype.clear = function () {
            this.__entries__.splice(0);
        };

        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        anonymous.prototype.forEach = function (callback, ctx) {
            var this$1 = this;
            if ( ctx === void 0 ) ctx = null;

            for (var i = 0, list = this$1.__entries__; i < list.length; i += 1) {
                var entry = list[i];

                callback.call(ctx, entry[1], entry[0]);
            }
        };

        Object.defineProperties( anonymous.prototype, prototypeAccessors );

        return anonymous;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }

    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }

    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }

    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }

    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;

/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
var throttle = function (callback, delay) {
    var leadingCall = false,
        trailingCall = false,
        lastCallTime = 0;

    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;

            callback();
        }

        if (trailingCall) {
            proxy();
        }
    }

    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }

    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();

        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }

            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        } else {
            leadingCall = true;
            trailingCall = false;

            setTimeout(timeoutCallback, delay);
        }

        lastCallTime = timeStamp;
    }

    return proxy;
};

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;

// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];

// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';

/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = function() {
    this.connected_ = false;
    this.mutationEventsAdded_ = false;
    this.mutationsObserver_ = null;
    this.observers_ = [];

    this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
    this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
};

/**
 * Adds observer to observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be added.
 * @returns {void}
 */


/**
 * Holds reference to the controller's instance.
 *
 * @private {ResizeObserverController}
 */


/**
 * Keeps reference to the instance of MutationObserver.
 *
 * @private {MutationObserver}
 */

/**
 * Indicates whether DOM listeners have been added.
 *
 * @private {boolean}
 */
ResizeObserverController.prototype.addObserver = function (observer) {
    if (!~this.observers_.indexOf(observer)) {
        this.observers_.push(observer);
    }

    // Add listeners if they haven't been added yet.
    if (!this.connected_) {
        this.connect_();
    }
};

/**
 * Removes observer from observers list.
 *
 * @param {ResizeObserverSPI} observer - Observer to be removed.
 * @returns {void}
 */
ResizeObserverController.prototype.removeObserver = function (observer) {
    var observers = this.observers_;
    var index = observers.indexOf(observer);

    // Remove observer if it's present in registry.
    if (~index) {
        observers.splice(index, 1);
    }

    // Remove listeners if controller has no connected observers.
    if (!observers.length && this.connected_) {
        this.disconnect_();
    }
};

/**
 * Invokes the update of observers. It will continue running updates insofar
 * it detects changes.
 *
 * @returns {void}
 */
ResizeObserverController.prototype.refresh = function () {
    var changesDetected = this.updateObservers_();

    // Continue running updates if changes have been detected as there might
    // be future ones caused by CSS transitions.
    if (changesDetected) {
        this.refresh();
    }
};

/**
 * Updates every observer from observers list and notifies them of queued
 * entries.
 *
 * @private
 * @returns {boolean} Returns "true" if any observer has detected changes in
 *  dimensions of it's elements.
 */
ResizeObserverController.prototype.updateObservers_ = function () {
    // Collect observers that have active observations.
    var activeObservers = this.observers_.filter(function (observer) {
        return observer.gatherActive(), observer.hasActive();
    });

    // Deliver notifications in a separate cycle in order to avoid any
    // collisions between observers, e.g. when multiple instances of
    // ResizeObserver are tracking the same element and the callback of one
    // of them changes content dimensions of the observed target. Sometimes
    // this may result in notifications being blocked for the rest of observers.
    activeObservers.forEach(function (observer) { return observer.broadcastActive(); });

    return activeObservers.length > 0;
};

/**
 * Initializes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.connect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already added.
    if (!isBrowser || this.connected_) {
        return;
    }

    // Subscription to the "Transitionend" event is used as a workaround for
    // delayed transitions. This way it's possible to capture at least the
    // final state of an element.
    document.addEventListener('transitionend', this.onTransitionEnd_);

    window.addEventListener('resize', this.refresh);

    if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);

        this.mutationsObserver_.observe(document, {
            attributes: true,
            childList: true,
            characterData: true,
            subtree: true
        });
    } else {
        document.addEventListener('DOMSubtreeModified', this.refresh);

        this.mutationEventsAdded_ = true;
    }

    this.connected_ = true;
};

/**
 * Removes DOM listeners.
 *
 * @private
 * @returns {void}
 */
ResizeObserverController.prototype.disconnect_ = function () {
    // Do nothing if running in a non-browser environment or if listeners
    // have been already removed.
    if (!isBrowser || !this.connected_) {
        return;
    }

    document.removeEventListener('transitionend', this.onTransitionEnd_);
    window.removeEventListener('resize', this.refresh);

    if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
    }

    if (this.mutationEventsAdded_) {
        document.removeEventListener('DOMSubtreeModified', this.refresh);
    }

    this.mutationsObserver_ = null;
    this.mutationEventsAdded_ = false;
    this.connected_ = false;
};

/**
 * "Transitionend" event handler.
 *
 * @private
 * @param {TransitionEvent} event
 * @returns {void}
 */
ResizeObserverController.prototype.onTransitionEnd_ = function (ref) {
        var propertyName = ref.propertyName; if ( propertyName === void 0 ) propertyName = '';

    // Detect whether transition may affect dimensions of an element.
    var isReflowProperty = transitionKeys.some(function (key) {
        return !!~propertyName.indexOf(key);
    });

    if (isReflowProperty) {
        this.refresh();
    }
};

/**
 * Returns instance of the ResizeObserverController.
 *
 * @returns {ResizeObserverController}
 */
ResizeObserverController.getInstance = function () {
    if (!this.instance_) {
        this.instance_ = new ResizeObserverController();
    }

    return this.instance_;
};

ResizeObserverController.instance_ = null;

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var i = 0, list = Object.keys(props); i < list.length; i += 1) {
        var key = list[i];

        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }

    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;

    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);

/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}

/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [], len = arguments.length - 1;
    while ( len-- > 0 ) positions[ len ] = arguments[ len + 1 ];

    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];

        return size + toFloat(value);
    }, 0);
}

/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};

    for (var i = 0, list = positions; i < list.length; i += 1) {
        var position = list[i];

        var value = styles['padding-' + position];

        paddings[position] = toFloat(value);
    }

    return paddings;
}

/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();

    return createRectInit(0, 0, bbox.width, bbox.height);
}

/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth;
    var clientHeight = target.clientHeight;

    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }

    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;

    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width),
        height = toFloat(styles.height);

    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }

        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }

    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;

        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }

        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }

    return createRectInit(paddings.left, paddings.top, width, height);
}

/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }

    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === 'function'; };
})();

/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}

/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }

    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }

    return getHTMLElementContentRect(target);
}

/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(ref) {
    var x = ref.x;
    var y = ref.y;
    var width = ref.width;
    var height = ref.height;

    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);

    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });

    return rect;
}

/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = function(target) {
    this.broadcastWidth = 0;
    this.broadcastHeight = 0;
    this.contentRect_ = createRectInit(0, 0, 0, 0);

    this.target = target;
};

/**
 * Updates content rectangle and tells whether it's width or height properties
 * have changed since the last broadcast.
 *
 * @returns {boolean}
 */


/**
 * Reference to the last observed content rectangle.
 *
 * @private {DOMRectInit}
 */


/**
 * Broadcasted width of content rectangle.
 *
 * @type {number}
 */
ResizeObservation.prototype.isActive = function () {
    var rect = getContentRect(this.target);

    this.contentRect_ = rect;

    return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
};

/**
 * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
 * from the corresponding properties of the last observed content rectangle.
 *
 * @returns {DOMRectInit} Last observed content rectangle.
 */
ResizeObservation.prototype.broadcastRect = function () {
    var rect = this.contentRect_;

    this.broadcastWidth = rect.width;
    this.broadcastHeight = rect.height;

    return rect;
};

var ResizeObserverEntry = function(target, rectInit) {
    var contentRect = createReadOnlyRect(rectInit);

    // According to the specification following properties are not writable
    // and are also not enumerable in the native implementation.
    //
    // Property accessors are not being used as they'd require to define a
    // private WeakMap storage which may cause memory leaks in browsers that
    // don't support this type of collections.
    defineConfigurable(this, { target: target, contentRect: contentRect });
};

var ResizeObserverSPI = function(callback, controller, callbackCtx) {
    this.activeObservations_ = [];
    this.observations_ = new MapShim();

    if (typeof callback !== 'function') {
        throw new TypeError('The callback provided as parameter 1 is not a function.');
    }

    this.callback_ = callback;
    this.controller_ = controller;
    this.callbackCtx_ = callbackCtx;
};

/**
 * Starts observing provided element.
 *
 * @param {Element} target - Element to be observed.
 * @returns {void}
 */


/**
 * Registry of the ResizeObservation instances.
 *
 * @private {Map<Element, ResizeObservation>}
 */


/**
 * Public ResizeObserver instance which will be passed to the callback
 * function and used as a value of it's "this" binding.
 *
 * @private {ResizeObserver}
 */

/**
 * Collection of resize observations that have detected changes in dimensions
 * of elements.
 *
 * @private {Array<ResizeObservation>}
 */
ResizeObserverSPI.prototype.observe = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is already being observed.
    if (observations.has(target)) {
        return;
    }

    observations.set(target, new ResizeObservation(target));

    this.controller_.addObserver(this);

    // Force the update of observations.
    this.controller_.refresh();
};

/**
 * Stops observing provided element.
 *
 * @param {Element} target - Element to stop observing.
 * @returns {void}
 */
ResizeObserverSPI.prototype.unobserve = function (target) {
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    // Do nothing if current environment doesn't have the Element interface.
    if (typeof Element === 'undefined' || !(Element instanceof Object)) {
        return;
    }

    if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
    }

    var observations = this.observations_;

    // Do nothing if element is not being observed.
    if (!observations.has(target)) {
        return;
    }

    observations.delete(target);

    if (!observations.size) {
        this.controller_.removeObserver(this);
    }
};

/**
 * Stops observing all elements.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.disconnect = function () {
    this.clearActive();
    this.observations_.clear();
    this.controller_.removeObserver(this);
};

/**
 * Collects observation instances the associated element of which has changed
 * it's content rectangle.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.gatherActive = function () {
        var this$1 = this;

    this.clearActive();

    this.observations_.forEach(function (observation) {
        if (observation.isActive()) {
            this$1.activeObservations_.push(observation);
        }
    });
};

/**
 * Invokes initial callback function with a list of ResizeObserverEntry
 * instances collected from active resize observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.broadcastActive = function () {
    // Do nothing if observer doesn't have active observations.
    if (!this.hasActive()) {
        return;
    }

    var ctx = this.callbackCtx_;

    // Create ResizeObserverEntry instance for every active observation.
    var entries = this.activeObservations_.map(function (observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
    });

    this.callback_.call(ctx, entries, ctx);
    this.clearActive();
};

/**
 * Clears the collection of active observations.
 *
 * @returns {void}
 */
ResizeObserverSPI.prototype.clearActive = function () {
    this.activeObservations_.splice(0);
};

/**
 * Tells whether observer has active observations.
 *
 * @returns {boolean}
 */
ResizeObserverSPI.prototype.hasActive = function () {
    return this.activeObservations_.length > 0;
};

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();

/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = function(callback) {
    if (!(this instanceof ResizeObserver)) {
        throw new TypeError('Cannot call a class as a function.');
    }
    if (!arguments.length) {
        throw new TypeError('1 argument required, but only 0 present.');
    }

    var controller = ResizeObserverController.getInstance();
    var observer = new ResizeObserverSPI(callback, controller, this);

    observers.set(this, observer);
};

// Expose public methods of ResizeObserver.
['observe', 'unobserve', 'disconnect'].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        return (ref = observers.get(this))[method].apply(ref, arguments);
        var ref;
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }

    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(26)))

/***/ }),

/***/ 710:
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(711);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),

/***/ 711:
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),

/***/ 712:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(2);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),

/***/ 713:
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(714);
module.exports = new MediaQueryDispatch();


/***/ }),

/***/ 714:
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(715);
var Util = __webpack_require__(681);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),

/***/ 715:
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(716);
var each = __webpack_require__(681).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),

/***/ 716:
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),

/***/ 717:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "8b1b68ce.png";

/***/ }),

/***/ 718:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "4b99387b.png";

/***/ }),

/***/ 719:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f1f8c8a7.png";

/***/ }),

/***/ 720:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "f660ac03.png";

/***/ }),

/***/ 721:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7e896ee8.jpeg";

/***/ }),

/***/ 722:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "2f45fb6a.jpg";

/***/ }),

/***/ 723:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "21f7608c.jpg";

/***/ }),

/***/ 724:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "7d3a0e9e.jpg";

/***/ }),

/***/ 725:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "88fe077b.jpg";

/***/ }),

/***/ 726:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "c8323a8f.jpg";

/***/ }),

/***/ 727:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "789a600d.jpg";

/***/ }),

/***/ 728:
/***/ (function(module, exports, __webpack_require__) {


    var content = __webpack_require__(729);
    var insertCss = __webpack_require__(22);

    if (typeof content === 'string') {
      content = [[module.i, content, '']];
    }

    module.exports = content.locals || {};
    module.exports._getContent = function() { return content; };
    module.exports._getCss = function() { return content.toString(); };
    module.exports._insertCss = function(options) { return insertCss(content, options) };
    
    // Hot Module Replacement
    // https://webpack.github.io/docs/hot-module-replacement
    // Only activated in browser context
    if (false) {
      var removeCss = function() {};
      module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Home.css", function() {
        content = require("!!../../../node_modules/css-loader/index.js??ref--1-rules-2!../../../node_modules/postcss-loader/lib/index.js??ref--1-rules-3!./Home.css");

        if (typeof content === 'string') {
          content = [[module.id, content, '']];
        }

        removeCss = insertCss(content, { replace: true });
      });
      module.hot.dispose(function() { removeCss(); });
    }
  

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(21)(false);
// imports
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Lato:400,\n  300italic,\n  300,\n  400italic,\n  700,\n  700italic|Open+Sans:400,\n  600,\n  700,\n  600italic,\n  700italic,\n  400italic,\n  300,\n  300italic,\n  800|Montserrat,\n  500,\n  600,\n  700|Roboto:400,\n  500,\n  400italic,\n  500italic,\n  700\n);", ""]);
exports.push([module.i, "@import url(https://fonts.googleapis.com/css?family=Montserrat&display=swap);", ""]);

// module
exports.push([module.i, "button:focus{outline:none}.slick-next,.slick-prev{display:none!important}.slick-slide{padding:0 20px}.slick-dots li{margin:0 16px}.slick-dots li button:before{content:\"\";background:#d8d8d8;opacity:1;height:10px;width:10px;border-radius:50%}.slick-dots li.slick-active button:before{content:\"\";background:#4d4cad;opacity:1;height:12px;width:12px;border-radius:50%}body{font:400 16px/26px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:.3px;color:#282828;margin:0}._296Mk,a,button{-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._296Mk,._296Mk:focus,._296Mk:hover,a,a:focus,a:hover,button,button:focus,button:hover{text-decoration:none;outline:none}h2,h3,h4,h5,h6,ul{margin:0;list-style:none;padding:0}footer._1MfJf,header._1MfJf,section._1MfJf{margin:0}._16f3L{z-index:-11!important}._3vZkm{border-top:1px solid #96909038;margin:0}._3kF8r{background-color:#f6f7fe}._2Jybw{padding:100px 0}._1Tho_{margin-top:0;position:relative;z-index:1;overflow:hidden}._1Tho_ ._1ZQZT{height:940px;position:relative;background:url(https://assets.ey.com/content/dam/ey-sites/ey-com/en_in/topics/climate-change/2021/05/ey-esg-integration-into-business.jpg.rendition.1800.1200.jpg) #1a1a24;background-size:cover;background-blend-mode:multiply;padding-top:200px}._2jjOy{width:100%;height:70vh}._1Tho_ ._1ZQZT ._2BckB{color:#fff;font-family:Montserrat,HelveticaNeue-Light,sans-serif;text-align:center}._1Tho_ ._1ZQZT ._2BckB h6{font:500 16px/30px Montserrat,HelveticaNeue-Light,sans-serif;padding-bottom:10px;text-align:center;margin:0}._1Tho_ ._1ZQZT ._2BckB h2{font-size:50px;line-height:65px;font-weight:700;padding-bottom:40px;text-align:center;margin:0}._1Tho_ ._1ZQZT ._2BckB ._1NwlD{text-decoration:none;font-size:12px;line-height:30px;text-transform:uppercase;font-weight:600;-webkit-box-shadow:0 16px 30px 0 rgba(0,0,0,.12);box-shadow:0 16px 30px 0 rgba(0,0,0,.12);padding:10px 33px 8px;border-radius:45px;display:inline-block;background-image:-webkit-linear-gradient(0deg,#4d4cad,#827ddc 43%,#9d9dcc);background-image:-ms-linear-gradient(0deg,#4d4cad 0,#827ddc 43%,#9d9dcc 100%);position:relative;z-index:1;color:#4d4cad;border:0}._1Tho_ ._1ZQZT ._2BckB ._1NwlD,._1Tho_ ._1ZQZT ._2BckB ._1NwlD:before{-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._1Tho_ ._1ZQZT ._2BckB ._1NwlD:before{content:\"\";position:absolute;left:0;width:100%;height:100%;top:0;border-radius:45px;background:#fff;z-index:-1}._1Tho_ ._1ZQZT ._2BckB ._1NwlD:hover{color:#fff}._1Tho_ ._1ZQZT ._2BckB ._1NwlD:hover:before{-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);opacity:0}._1Tho_ ._1afBP{position:absolute;bottom:0;left:0;width:100%;height:120px}._1Tho_ ._1afBP svg{height:100%;left:50%;position:absolute;width:100%;-webkit-transform:translatex(-50%) scaley(-1);-ms-transform:translatex(-50%) scaley(-1);transform:translatex(-50%) scaley(-1)}._1Tho_ ._8Bg-u{position:relative;text-align:center;margin-top:-460px;width:100%}._1Tho_ ._8Bg-u img{max-width:80%;vertical-align:middle}._1Tho_ ._16lEt{position:absolute;top:0;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);width:710px;background:#fff}._1Tho_ ._16lEt img{top:68px;left:-1px}._1Tho_ ._16lEt img,.YQ5UI{position:absolute;width:100%}.YQ5UI{top:0;height:100%;z-index:1}.YQ5UI span{width:50px;height:50px;border-radius:50%;background:hsla(0,0%,100%,.1);position:absolute;z-index:-1}.YQ5UI span:first-child{width:150px;height:150px;top:41%;left:25%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-animation:_3I_bz 3s linear 0s infinite alternate;animation:_3I_bz 3s linear 0s infinite alternate}.YQ5UI span:nth-child(2){width:100px;height:100px;left:30%}.YQ5UI span:nth-child(2),.YQ5UI span:nth-child(3){-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);top:30%}.YQ5UI span:nth-child(3){left:24%;-webkit-animation:_3I_bz 2s linear 0s infinite alternate;animation:_3I_bz 2s linear 0s infinite alternate}.YQ5UI span:nth-child(4){width:100px;height:100px;right:18%;top:21%;-webkit-animation:_3I_bz 7s linear 0s infinite alternate;animation:_3I_bz 7s linear 0s infinite alternate}.YQ5UI span:nth-child(4),.YQ5UI span:nth-child(5){-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%)}.YQ5UI span:nth-child(5){right:25%;top:30%}.YQ5UI span:nth-child(6){left:0;width:100px;height:100px;top:10%;-webkit-animation:_3I_bz 7s linear 0s infinite alternate;animation:_3I_bz 7s linear 0s infinite alternate}.YQ5UI span:nth-child(7){right:-18px;width:100px;height:100px;bottom:32%;-webkit-animation:YvFqr 9s linear infinite,_2QxDU 2s ease-in-out infinite alternate;animation:YvFqr 9s linear infinite,_2QxDU 2s ease-in-out infinite alternate}@-webkit-keyframes _3I_bz{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.5);transform:scale(.5)}}@keyframes _3I_bz{0%{-webkit-transform:scale(1);transform:scale(1)}to{-webkit-transform:scale(.5);transform:scale(.5)}}@-webkit-keyframes YvFqr{0%{top:500px}to{top:-500px}}@-webkit-keyframes _2QxDU{0%{right:0}to{right:50px}}._2V-WR{z-index:99999;background-color:#505cfe;opacity:.98}._2V-WR,._2V-WR ._TsT6{position:fixed;top:0;left:0;right:0;bottom:0}._2V-WR ._TsT6{width:200px;height:120px;margin:auto;text-align:center}._2V-WR ._TsT6 ._2P5Bj{position:relative;height:100%;width:100%}._2V-WR ._TsT6 ._2P5Bj .ddYbc{position:relative;width:80px;height:80px;margin-left:auto;margin-right:auto;font-size:0;border:1px dashed hsla(0,0%,100%,.2)}._2V-WR ._TsT6 ._2P5Bj .ddYbc .CaF-K{display:inline-block;width:39px;height:39px;position:absolute;background-color:#fff}._2V-WR ._TsT6 ._2P5Bj .ddYbc .CaF-K:first-of-type{left:0;top:0;animation:WH8kk 7s infinite linear;-webkit-animation:WH8kk 7s infinite linear;-o-animation:WH8kk 7s infinite linear;-moz-animation:WH8kk 7s infinite linear;-ms-animation:WH8kk 7s infinite linear}._2V-WR ._TsT6 ._2P5Bj .ddYbc .CaF-K:nth-of-type(2){right:0;bottom:0;animation:_3RBT5 7s infinite linear;-webkit-animation:_3RBT5 7s infinite linear;-o-animation:_3RBT5 7s infinite linear;-moz-animation:_3RBT5 7s infinite linear;-ms-animation:_3RBT5 7s infinite linear}._2V-WR ._TsT6 ._2P5Bj p{position:absolute;left:0;right:0;bottom:-16px;color:#fff;text-transform:uppercase;letter-spacing:8px}@keyframes WH8kk{0%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}25%{-webkit-transform:translate(39px);-ms-transform:translate(39px);transform:translate(39px)}45%{-webkit-transform:translate(39px);-ms-transform:translate(39px);transform:translate(39px)}50%{-webkit-transform:translate(39px,39px);-ms-transform:translate(39px,39px);transform:translate(39px,39px)}70%{-webkit-transform:translate(39px,39px);-ms-transform:translate(39px,39px);transform:translate(39px,39px)}75%{-webkit-transform:translateY(39px);-ms-transform:translateY(39px);transform:translateY(39px)}95%{-webkit-transform:translateY(39px);-ms-transform:translateY(39px);transform:translateY(39px)}to{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}}@-webkit-keyframes WH8kk{0%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}25%{-webkit-transform:translate(39px);-ms-transform:translate(39px);transform:translate(39px)}45%{-webkit-transform:translate(39px);-ms-transform:translate(39px);transform:translate(39px)}50%{-webkit-transform:translate(39px,39px);-ms-transform:translate(39px,39px);transform:translate(39px,39px)}70%{-webkit-transform:translate(39px,39px);-ms-transform:translate(39px,39px);transform:translate(39px,39px)}75%{-webkit-transform:translateY(39px);-ms-transform:translateY(39px);transform:translateY(39px)}95%{-webkit-transform:translateY(39px);-ms-transform:translateY(39px);transform:translateY(39px)}to{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}}@keyframes _3RBT5{0%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}25%{-webkit-transform:translate(-39px);-ms-transform:translate(-39px);transform:translate(-39px)}45%{-webkit-transform:translate(-39px);-ms-transform:translate(-39px);transform:translate(-39px)}50%{-webkit-transform:translate(-39px,-39px);-ms-transform:translate(-39px,-39px);transform:translate(-39px,-39px)}70%{-webkit-transform:translate(-39px,-39px);-ms-transform:translate(-39px,-39px);transform:translate(-39px,-39px)}75%{-webkit-transform:translateY(-39px);-ms-transform:translateY(-39px);transform:translateY(-39px)}95%{-webkit-transform:translateY(-39px);-ms-transform:translateY(-39px);transform:translateY(-39px)}to{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}}@-webkit-keyframes _3RBT5{0%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}20%{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}25%{-webkit-transform:translate(-39px);-ms-transform:translate(-39px);transform:translate(-39px)}45%{-webkit-transform:translate(-39px);-ms-transform:translate(-39px);transform:translate(-39px)}50%{-webkit-transform:translate(-39px,-39px);-ms-transform:translate(-39px,-39px);transform:translate(-39px,-39px)}70%{-webkit-transform:translate(-39px,-39px);-ms-transform:translate(-39px,-39px);transform:translate(-39px,-39px)}75%{-webkit-transform:translateY(-39px);-ms-transform:translateY(-39px);transform:translateY(-39px)}95%{-webkit-transform:translateY(-39px);-ms-transform:translateY(-39px);transform:translateY(-39px)}to{-webkit-transform:translate(0);-ms-transform:translate(0);transform:translate(0)}}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;-moz-appearance:none;appearance:none;margin:0}.FQZvp{padding-bottom:50px}.FQZvp ._2d-up{border:0}.FQZvp ._2d-up svg path{stroke:#ffe73e}.FQZvp ._2d-up ._2u_IQ h4:hover,.FQZvp ._2d-up .fw-6n a:hover{color:#ffe73e}.DNprC{text-align:center;padding:50px 30px;border:1px solid #eeefff;border-left:none}.DNprC ._15QtM{width:100%;height:60px}.DNprC ._15QtM svg{width:60px;height:60px;stroke-dasharray:2500px;-webkit-animation:_2z6TF 2s linear;animation:_2z6TF 2s linear}@-webkit-keyframes _2z6TF{0%{stroke-dashoffset:2500px}to{stroke-dashoffset:0}}@keyframes _2z6TF{0%{stroke-dashoffset:2500px}to{stroke-dashoffset:0}}.DNprC ._2u_IQ h4{font:600 18px Montserrat,HelveticaNeue-Light,sans-serif;color:#282828;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear;padding-top:25px}.DNprC ._2u_IQ h4:hover{color:#505cfe}.DNprC ._2u_IQ p{margin-top:0;font:400 14px/22px Montserrat,HelveticaNeue-Light,sans-serif;color:#787878;padding:22px 0 10px}.DNprC ._2u_IQ a,.DNprC ._2u_IQ p{-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}.DNprC ._2u_IQ a{font-size:24px;color:#282828;display:inline-block}.DNprC ._2u_IQ a:hover{color:#505cfe}i._2Pr23{display:inline-block;width:16px;height:16px;border-bottom:2px solid #282828;border-right:2px solid #282828;-webkit-transform:rotate(-45deg);-ms-transform:rotate(-45deg);transform:rotate(-45deg);border-radius:7%;position:relative}i._2Pr23:before{content:\" \";display:block;height:2px;width:24px;-webkit-transform:rotate(45deg);-ms-transform:rotate(45deg);transform:rotate(45deg);position:absolute;top:7px;left:-5px;background:#282828}._28OYM{background:#f6f7fe;padding:100px 0}._3-jA8{padding:0 50px;text-align:center}._3-jA8 h3{font-size:18px;line-height:40px;font-weight:300;color:#787878}._3-jA8 ._1XxxQ,._3-jA8 h3 span{font-weight:600;color:#282828}._3-jA8 ._1XxxQ{min-height:20px;margin-top:50px;padding:15px 30px 15px 65px;position:relative;display:inline-block;font-size:14px;line-height:1.4;font-family:Montserrat,HelveticaNeue-Light,sans-serif;border:1px solid #505cfe;border-radius:45px;cursor:pointer}._3-jA8 ._1XxxQ ._27d1-{width:60px;height:60px;border-radius:50%;background:#ffe73e;text-align:center;display:inline-block;position:absolute;top:50%;left:-10px;margin-top:-30px;line-height:66px;font-size:30px;color:#fff;z-index:1}._3-jA8 ._1XxxQ ._27d1-:before{width:72px;height:72px;border:1px solid #ffe73e;top:-6px;left:-6px;border-radius:50%}._3-jA8 ._1XxxQ ._27d1-:after,._3-jA8 ._1XxxQ ._27d1-:before{content:\"\";position:absolute;z-index:-1;-webkit-animation:Wvs1H 2s infinite linear;animation:Wvs1H 2s infinite linear}._3-jA8 ._1XxxQ ._27d1-:after{width:74px;height:74px;background:rgba(80,92,254,.5);top:-7px;left:-7px;border-radius:50%}._3-jA8 ._1XxxQ.Sxuxe{border-color:#ffe73e}._3-jA8 ._1XxxQ.Sxuxe ._27d1-{background:#ffe73e}._3-jA8 ._1XxxQ.Sxuxe ._27d1-:before{border-color:#ffe73e}._3-jA8 ._1XxxQ.Sxuxe ._27d1-:after{background:#1a1a24}._1_PR0{display:inline-block;margin:0 5px;margin-top:-9px;vertical-align:middle;width:0;height:0;border-left:15px solid #fff;border-bottom:10px solid transparent;border-top:10px solid transparent}@-webkit-keyframes Wvs1H{0%{-webkit-transform:scale(.68);transform:scale(.68)}to{-webkit-transform:scale(1.2);transform:scale(1.2);opacity:0}}@keyframes Wvs1H{0%{-webkit-transform:scale(.68);transform:scale(.68)}to{-webkit-transform:scale(1.2);transform:scale(1.2);opacity:0}}._1a2x5{margin-bottom:60px}.-va0n{margin-bottom:80px}.-va0n h6{font-size:16px;color:#989898;text-transform:uppercase;font-family:Lato,sans-serif;letter-spacing:2px;padding-bottom:10px}.-va0n h2{font:300 30px/40px Montserrat,HelveticaNeue-Light,sans-serif;letter-spacing:1px;color:#282828;position:relative;padding:0 20px;display:inline-block}.-va0n h2:after,.-va0n h2:before{content:\"\";position:absolute;top:50%;width:50px;height:2px;background:#505cfe}.-va0n h2:before{left:100%}.-va0n h2:after{right:100%}.-va0n h2 span{color:#505cfe}._1PLXZ{padding:40px 0}.w7XFR{position:relative;color:#fff;-webkit-transform-style:preserve-3d;transform-style:preserve-3d;-webkit-perspective:1000px;perspective:1000px;margin-bottom:30px;cursor:pointer}.w7XFR ._2bER2,.w7XFR ._3Xlcm{transition:transform .6s ease,-webkit-transform .6s ease;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:rotateX(0);transform:rotateX(0);-webkit-transform-style:preserve-3d;transform-style:preserve-3d;min-height:350px;height:auto;-webkit-box-shadow:0 0 42px 0 rgba(0,0,0,.08);box-shadow:0 0 42px 0 rgba(0,0,0,.08)}.w7XFR ._3Xlcm{background:#fff}.w7XFR ._3Xlcm ._1jSfu h4{color:#282828}.w7XFR ._3Xlcm ._1jSfu p{color:#8d8d8d}.w7XFR ._1jSfu{position:absolute;left:0;top:50%;width:100%;border-radius:2px;outline:1px solid transparent;-webkit-perspective:inherit;perspective:inherit;-webkit-backface-visibility:hidden;backface-visibility:hidden;-webkit-transform:translateY(-50%) translateZ(60px) scale(.94);transform:translateY(-50%) translateZ(60px) scale(.94);z-index:2;text-align:center;padding:20px}.w7XFR ._1jSfu h4{font:700 22px/26px Montserrat,HelveticaNeue-Light,sans-serif;padding-bottom:20px;padding-top:20px}.w7XFR ._1jSfu p{font:400 14px/30px Montserrat,HelveticaNeue-Light,sans-serif;text-align:center}.w7XFR ._1jSfu a{font:600 16px/22px Montserrat,HelveticaNeue-Light,sans-serif;color:#fff}.w7XFR ._2bER2{position:absolute;top:0;left:0;width:100%;background:#ffe73e;color:#1a1a24;border-radius:2px;-webkit-transform:rotateX(180deg);transform:rotateX(180deg);-webkit-transform-style:preserve-3d;transform-style:preserve-3d}.w7XFR:hover ._3Xlcm{-webkit-transform:rotateX(-180deg);transform:rotateX(-180deg)}.w7XFR:hover ._2bER2{-webkit-transform:rotateX(0deg);transform:rotateX(0deg)}._1xyQz ._2bER2,._1xyQz ._3Xlcm{-webkit-box-shadow:0 0 42px 0 rgba(0,0,0,.008);box-shadow:0 0 42px 0 rgba(0,0,0,.008)}._1jKnt h2{text-align:center}._3oOL5{padding:40px 0}._26Cka ._1_Xau ._3hDRy{padding:15px}._26Cka ._1wDO5{text-align:center}._26Cka ._1wDO5 ._29QIz{width:12px;height:12px;border-radius:50%;background:#f1f1f1;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear;display:inline-block;-webkit-transform:scale(.9);-ms-transform:scale(.9);transform:scale(.9);margin:60px 5px 0}._26Cka ._1wDO5 ._29QIz._2pdKw{background:#505cfe;-webkit-transform:scale(1.01);-ms-transform:scale(1.01);transform:scale(1.01)}._2Uqnk{text-align:center;font-family:Montserrat,HelveticaNeue-Light,sans-serif;padding:125px 40px;-webkit-transition:.5s ease-in-out;-o-transition:.5s ease-in-out;transition:.5s ease-in-out;border-top:5px solid transparent;border-bottom:5px solid transparent;border-radius:10px;cursor:pointer}._2Uqnk ._1Kv6l{width:130px;height:130px;border-radius:50%;overflow:hidden;border:5px solid #f4f4f4;display:inline-block;margin-bottom:25px;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._2Uqnk ._1Kv6l img{max-width:100%;-webkit-transition:all .6s linear;-o-transition:all .6s linear;transition:all .6s linear}._2Uqnk h4{font-weight:600;color:#282828;font-size:22px;line-height:30px;padding-bottom:10px}._2Uqnk h6{font-size:14px;color:#787878;font-weight:300}._2Uqnk hr{width:74%;margin:16px auto}._2Uqnk ._3Ch4m{display:inline-block}._2Uqnk ._3Ch4m ._32yq6{font-size:14px;font-weight:400;font-family:Montserrat,HelveticaNeue-Light,sans-serif;position:relative;display:inline-block}._2Uqnk ._3Ch4m ._32yq6+._32yq6{display:block}._2Uqnk ._3Ch4m ._32yq6 a{color:#282828;padding-left:22px;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._2Uqnk ._3Ch4m ._32yq6 a:hover{text-decoration:underline;color:#505cfe}._2Uqnk ._3Ch4m ._32yq6 i{color:#505cfe;position:absolute;left:0;top:4px}._2Uqnk:hover{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}._2Uqnk:hover,._2Uqnk:hover ._1Kv6l{border-color:#505cfe}._2Uqnk:hover ._1Kv6l img{-webkit-transform:scale(1.06);-ms-transform:scale(1.06);transform:scale(1.06)}._3azDT ._2Uqnk{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15)}._3azDT ._2Uqnk,._3azDT ._2Uqnk ._1Kv6l{border-color:#505cfe}._3azDT ._2Uqnk ._1Kv6l img{-webkit-transform:scale(1.06);-ms-transform:scale(1.06);transform:scale(1.06)}.dvHjq ._2Uqnk{background:#fff}.dvHjq ._2Uqnk ._3Ch4m ._32yq6 i{color:#f66164}.dvHjq ._2Uqnk ._3Ch4m ._32yq6 ._2Fxxu:hover{color:#827ddc}.dvHjq ._2Uqnk:hover{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-color:#827ddc}.dvHjq ._2Uqnk:hover ._1Kv6l{border-color:#827ddc}.dvHjq ._2Uqnk:hover ._1Kv6l img{-webkit-transform:scale(1.06);-ms-transform:scale(1.06);transform:scale(1.06)}.dvHjq ._3azDT ._2Uqnk{-webkit-box-shadow:0 1px 4px 0 rgba(0,0,0,.15);box-shadow:0 1px 4px 0 rgba(0,0,0,.15);border-color:#f66164;background:#fff}.dvHjq ._3azDT ._2Uqnk ._1Kv6l{border-color:#f66164}.dvHjq ._3azDT ._2Uqnk ._1Kv6l img{-webkit-transform:scale(1.06);-ms-transform:scale(1.06);transform:scale(1.06)}.dvHjq ._26Cka ._1wDO5 ._29QIz._2pdKw{background:#f66164}._1jKnt h2{line-height:1.2;font-size:40px;font-weight:600;font-family:Montserrat,HelveticaNeue-Light,sans-serif;color:#282828;text-transform:uppercase;position:relative;padding-bottom:20px}._1jKnt h2:before{content:\"\";width:60px;height:3px;background:#505cfe;left:50%;-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);bottom:0;position:absolute}._1jKnt h2 span{font-weight:300;padding-right:5px}._1jKnt._3olfH h2:before{background-image:-webkit-linear-gradient(0deg,#ed3d82,#f66164 43%,#fe8545);background-image:-webkit-linear-gradient(0deg,#4d4cad,#827ddc 43%,#9d9dcc);background-image:-ms-linear-gradient(0deg,#4d4cad 0,#827ddc 43%,#9d9dcc 100%)}._3ix14{padding:29px 116px 0;font:400 16px/30px Montserrat,sans-serif;letter-spacing:.5px;color:#282828;text-align:center;margin-bottom:60px}._3k6A1{padding-top:0}._1MJzy{position:relative}._1MJzy._2wExH .C2e_- h4:hover{border-color:#827ddc}._1MJzy._2wExH .C2e_- h6{font:500 16px/20px Montserrat,sans-serif;color:#8c97a1;padding-top:10px}._1MJzy._2wExH .C2e_- h6:after{width:50px;height:1px;background:#8c97a1;display:none;margin-left:15px}._1MJzy._2wExH .C2e_- a:hover{text-decoration:underline;border-color:#827ddc}._1MJzy._2wExH .C2e_- a:hover i{color:#505cfe;-webkit-text-fill-color:#505cfe}.SHAiw{padding-top:2px}._1MJzy:hover ._110ez:after{opacity:1}._110ez{position:relative;display:block}._110ez:after{content:\"\";position:absolute;top:0;left:0;width:100%;height:100%;background-image:-webkit-linear-gradient(90deg,rgba(0,0,0,.8),transparent);background-image:-ms-linear-gradient(90deg,rgba(0,0,0,.8) 0,transparent 100%);opacity:0;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._110ez img{border-radius:3px;width:100%}.Cppm_{font-family:Montserrat,sans-serif;position:absolute;top:15px;font-size:14px;color:#fff;width:65px;height:65px;text-align:center;padding-top:6px;left:15px;background:#43cea2}.Cppm_ span{font-size:22px;display:block}.Cppm_:after{position:absolute;content:\"\";width:0;height:0;border-top:0 solid transparent;border-bottom:20px solid transparent;border-left:15px solid #43cea2;bottom:-20px;left:0}.C2e_-{padding-top:17px}.C2e_- h4{font:700 18px/30px Montserrat,sans-serif;letter-spacing:.5px;color:#282828;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}.C2e_- h4:hover{color:#827ddc}.C2e_- p{font:400 14px/24px Montserrat,sans-serif;color:#8c97a1;padding-top:15px}.C2e_- a,.C2e_- p{letter-spacing:.5px}.C2e_- a{font:500 14px/18px Montserrat,sans-serif;color:#185a9d;text-transform:capitalize;padding-top:12px;display:inline-block;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}.C2e_- a i{-webkit-transition-timing-function:ease-out;-o-transition-timing-function:ease-out;transition-timing-function:ease-out;-webkit-transform:translateZ(0);transform:translateZ(0);-webkit-transition-property:-webkit-transform;transition-property:-webkit-transform;-o-transition-property:transform;transition-property:transform;transition-property:transform,-webkit-transform;-webkit-transition-duration:.4s;-o-transition-duration:.4s;transition-duration:.4s}.C2e_- a:hover{color:#827ddc}.C2e_- a:hover i{-webkit-transform:translateX(4px);-ms-transform:translateX(4px);transform:translateX(4px);color:#827ddc;-webkit-background-clip:text;-webkit-text-fill-color:transparent;background-image:-webkit-linear-gradient(0deg,#185a9d,#43cea2);background-image:-ms-linear-gradient(0deg,#185a9d 0,#43cea2 100%)}._2Sf-s ._2wExH .C2e_- a:hover{color:#827ddc;text-decoration:none}._2Sf-s ._2wExH .C2e_- a:hover i{color:#827ddc;-webkit-text-fill-color:#f66164}._2Sf-s ._2wExH .C2e_- h4:hover{color:#827ddc}._2Sf-s .fiNJI ._2kGpI ._3d6ZN:focus{border-color:#f66164}._2Sf-s .fiNJI ._2uBAw{color:#827ddc;border-color:#827ddc}._2Sf-s .fiNJI ._2uBAw:hover{background:#827ddc}._1k1mw{background:#f6f7fe;padding:90px 35px;position:relative;margin-top:100px}._1k1mw:before{content:\"\";position:absolute;top:-45px;left:50%;width:55px;height:55px;margin-left:0;background:#fff;-webkit-transform:translateX(-50%) rotate(-45deg);-ms-transform:translateX(-50%) rotate(-45deg);transform:translateX(-50%) rotate(-45deg)}.sZW4X{margin-top:40px}.sZW4X ._2qeGn{width:260px;margin:10px 8px;display:inline-block}.sZW4X ._2qeGn ._3d6ZN{font-size:14px;color:#9f9f9f;height:auto;min-height:52px;padding:12px 19px 11px;border:1px solid transparent;-webkit-box-shadow:0 0 30px 0 rgba(0,0,0,.015);box-shadow:0 0 30px 0 rgba(0,0,0,.015);border-radius:4px;-webkit-appearance:none;line-height:25px;background-color:#fff;display:block;width:100%}.sZW4X ._2qeGn select._3d6ZN{height:52px}.sZW4X ._2qeGn ._3d6ZN:focus{outline:none;border-color:#827ddc}.sZW4X ._3r09h{width:195px}.sZW4X ._2uBAw{display:block;width:100%;border-radius:4px;padding:12px 35px;background:transparent;border:1px solid #827ddc;text-transform:uppercase;font-size:14px;font-weight:700;color:#827ddc;min-height:52px;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear;cursor:pointer}.sZW4X ._2uBAw:hover{color:#fff;background:#827ddc}._2ImFS{background:#f7f7f7;padding:91px 0 70px}._2ImFS ._1M6LT .rf2Vu{text-align:center}._2ImFS ._1M6LT .rf2Vu a{display:inline-block;-webkit-transition:all .5s ease-in-out;-o-transition:all .5s ease-in-out;transition:all .5s ease-in-out}._2ImFS ._1M6LT .rf2Vu a img{max-width:100%;-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);-ms-filter:grayscale(100%);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /></filter></svg>#filter');filter:grayscale(100%);-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._2ImFS ._1M6LT .rf2Vu a:hover img{-webkit-filter:grayscale(0);-moz-filter:grayscale(0);-ms-filter:grayscale(0);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\" /></filter></svg>#filter');filter:grayscale(0)}._1LzKQ{background:#fff;padding:100px 0}._1LzKQ .rf2Vu{width:170px;height:70px;text-align:center;border:1px solid #f3f6f9;padding-top:20px}._1LzKQ .rf2Vu a{border:0}._3ooGW .rf2Vu a{border:1px solid #f3f6f9;line-height:68px;display:block}._3ooGW .rf2Vu a img{max-width:100%;-webkit-filter:grayscale(100%);-moz-filter:grayscale(100%);-ms-filter:grayscale(100%);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0\" /></filter></svg>#filter');filter:grayscale(100%);-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._3ooGW .rf2Vu a:hover img{-webkit-filter:grayscale(0);-moz-filter:grayscale(0);-ms-filter:grayscale(0);filter:url('data:image/svg+xml;charset=utf-8,<svg xmlns=\"http://www.w3.org/2000/svg\"><filter id=\"filter\"><feColorMatrix type=\"matrix\" color-interpolation-filters=\"sRGB\" values=\"1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0\" /></filter></svg>#filter');filter:grayscale(0)}._3TLAE{padding-top:126px;padding-bottom:100px;background:#fff}._3TLAE ._3ix14{margin-bottom:78px}._3TLAE ._3ooGW{text-align:center}._3TLAE ._3ooGW+._3ooGW{margin-top:30px}._3m6HW img{width:36%;margin:auto}._31JR5 ._3YPN-{width:87%;margin:auto}._1nxjd._2Jybw{padding-bottom:0}._1nxjd ._26zha{text-align:center;margin-bottom:60px;margin-top:-5px}._1nxjd ._26zha li{display:inline-block;color:#222;font-size:15px;padding:8px 15px;text-transform:capitalize;border-bottom:1px dotted #909090;border-top:1px dotted #909090;-webkit-transition:all .3s ease-in-out;-o-transition:all .3s ease-in-out;transition:all .3s ease-in-out;margin:0 3px;cursor:pointer}._1nxjd ._26zha li._2pdKw,._1nxjd ._26zha li:hover{color:#fff;border-color:#505cfe}._1nxjd ._3c2mN ._2Sxbu{padding:0;position:relative;display:none}._3vxzB{display:block!important}._1nxjd ._3c2mN ._2Sxbu img{display:block;width:100%;height:auto;-webkit-transition:all .5s ease;-o-transition:all .5s ease;transition:all .5s ease;overflow:hidden}._1nxjd ._3c2mN ._2Sxbu ._2HtvN{background-color:hsla(0,0%,100%,.8);position:absolute;left:10px;top:10px;bottom:10px;right:10px;width:auto;height:inherit;color:#04bee4!important;opacity:0;z-index:1;filter:alpha(opacity=0);padding:2%;-webkit-transition:all .45s ease-out 0s;-o-transition:all .45s ease-out 0s;transition:all .45s ease-out 0s}._1nxjd ._3c2mN ._2Sxbu ._2HtvN ._2rue4{position:absolute;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);width:100%;left:0}._1nxjd ._3c2mN ._2Sxbu ._2HtvN ._2rue4 h4{font:500 22px/28px Montserrat,sans-serif;color:#282828;text-align:center}._1nxjd ._3c2mN ._2Sxbu ._2HtvN ._2rue4 p{font:400 16px/22px Montserrat,sans-serif;color:#888;text-align:center}._1nxjd ._3c2mN ._2Sxbu ._2HtvN ._2rue4 .f9-Tt{height:1px;margin:15px auto;background-color:#505cfe;width:0;-webkit-transition:all .5s ease-out;-o-transition:all .5s ease-out;transition:all .5s ease-out}._1nxjd ._3c2mN ._2Sxbu:hover ._2HtvN{opacity:1}._1nxjd ._3c2mN ._2Sxbu:hover ._2HtvN .f9-Tt{width:50%}._2LRuQ{padding-top:100px}._2LRuQ ._26zha li{-webkit-transition:all .1s linear;-o-transition:all .1s linear;transition:all .1s linear}._2LRuQ ._26zha li._2pdKw{background:#f66164;*/border-color:#827ddc;background:#827ddc}._2LRuQ ._26zha li:hover{border-color:#f66164;*/border-color:#827ddc;background:#827ddc}._2LRuQ ._3c2mN ._2Sxbu ._2HtvN ._2rue4 .f9-Tt{background:#f66164}._3c2mN{display:grid;grid-gap:1px;grid-template-columns:1fr 1fr 1fr}._1U_Gk{background-attachment:fixed}._1U_Gk .Ouhz3{background:rgba(0,0,0,.2);padding:96px 0 90px}._1U_Gk .Ouhz3 ._3BuEt{font:400 14px/24px Montserrat,sans-serif;letter-spacing:.5px;color:#555}._3BuEt ._3c8O_{font:700 28px Lato,sans-serif;text-transform:capitalize;color:#fff;margin-top:7px;margin-bottom:35px}.G_83E a{display:block}.G_83E ul{margin-top:30px}.G_83E ul li{list-style:none;display:table;width:100%;padding-bottom:10px;color:#8b8b8b}.G_83E ul li i{float:left;font-size:16px;width:30px;line-height:24px;color:#5a5a5a}.G_83E ul li ._2yL1u{float:left;width:calc(100% - 34px)}.G_83E p{padding-top:20px;color:#8b8b8b}._1U_Gk .Ouhz3 ._1LA8Y ul li{padding:9px 0;border-top:1px solid rgba(90,90,90,.3)}._1U_Gk .Ouhz3 ._1LA8Y ul li a{color:#8b8b8b;letter-spacing:0}._1U_Gk .Ouhz3 ._1LA8Y ul li a:hover{border-left:2px solid #43cea2;color:#fff;padding-left:12px}._1U_Gk .Ouhz3 ._1LA8Y ul li:first-child{border-top:none}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m{padding-top:10px}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .EEVHL{padding:6px 15px 0 0;position:relative}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .EEVHL ._2_Pft{padding:2px;position:relative;z-index:1}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .EEVHL ._2_Pft img{border-radius:3px}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .EEVHL ._2_Pft:before{border:3px solid #43cea2;border-radius:3px;content:\"\";position:absolute;top:0;left:0;bottom:0;right:0;display:block;z-index:-1;opacity:0;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD{cursor:pointer}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD h3{border-bottom:1px solid #2a2929;padding-bottom:20px;position:relative;font:400 14px/24px Montserrat,sans-serif;color:#8b8b8b}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD h3,._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD h3:before{-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD h3:before{content:\"\";color:#fff;position:absolute;left:0;right:0;height:1px;bottom:0;opacity:0}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m .qdRsD a{color:#8b8b8b;font:400 9px/24px Montserrat,sans-serif;letter-spacing:.5px;font-style:italic;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m+._3bh3m{margin-top:20px;border-top:1px solid rgba(90,90,90,.3);padding-top:19px}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m:hover ._2_Pft:before{opacity:1}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m:hover .qdRsD h3{color:#fff}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m:hover .qdRsD h3:before{opacity:1}._1U_Gk .Ouhz3 ._3-XOQ ._3bh3m:hover .qdRsD a{color:gray}._1U_Gk .Ouhz3 .n5uCL ._1AfRb{font:400 14px/30px Montserrat,sans-serif;letter-spacing:.5px;padding-top:15px}._1U_Gk .Ouhz3 .n5uCL ._1AfRb ._3d6ZN{font:400 14px/38px Montserrat,sans-serif;letter-spacing:.5px;background:#2a2929;border:0;border-radius:3px;margin-bottom:5px;outline:none;-webkit-box-shadow:none;box-shadow:none;padding:0 17px;height:40px;color:#b6b6b6;text-transform:capitalize;width:100%}._3d6ZN::-webkit-input-placeholder{color:#5d5b5b;opacity:1}._3d6ZN:-ms-input-placeholder,._3d6ZN::-ms-input-placeholder{color:#5d5b5b;opacity:1}._3d6ZN::placeholder{color:#5d5b5b;opacity:1}._1U_Gk .Ouhz3 .n5uCL ._1AfRb ._3BPvV{resize:none;height:98px}._1U_Gk .Ouhz3 .n5uCL .pZBxf{color:#fff;text-transform:capitalize;padding:5px 34px}._1U_Gk .Ouhz3 .n5uCL .pZBxf:hover{background-color:#5d5b5b;cursor:pointer}._1U_Gk ._1-qLJ{background:hsla(0,3%,7%,.6);font:400 14px/30px Montserrat,sans-serif;border-top:1px solid hsla(0,0%,100%,.07);letter-spacing:.3px;color:#555;padding:30px 0 25px;margin-top:-1px;position:relative}._1U_Gk ._1-qLJ ._1aRAb{background:#43cea2;color:#fff;width:70px;height:70px;display:block;text-align:center;border-radius:50%;position:absolute;left:calc(50% - 35px);cursor:pointer;top:-36px}._1U_Gk ._1-qLJ ._1aRAb i{font-size:30px;line-height:68px}._1U_Gk ._1-qLJ a{color:#43cea2}._1U_Gk ._1-qLJ ._12KTb{float:right;overflow:hidden}._1U_Gk ._1-qLJ ._12KTb li{float:left;padding-right:10px}._1U_Gk ._1-qLJ ._12KTb li a{border-radius:50%;width:30px;padding:0;text-align:center;background:#43cea2;-webkit-transition:all .3s linear 0s;-o-transition:all .3s linear 0s;transition:all .3s linear 0s;-webkit-transition-duration:.3s;-o-transition-duration:.3s;transition-duration:.3s}._1U_Gk ._1-qLJ ._12KTb li a i{font-size:14px;line-height:30px;color:#fff}._1U_Gk ._1-qLJ ._12KTb li:hover a{background:#2a2929;color:#fff}.HDRdS .Ouhz3 ._1LA8Y ul li a:hover,.HDRdS .Ouhz3 ._3-XOQ ._3bh3m .EEVHL ._2_Pft:before{border-color:#827ddc}.HDRdS ._1-qLJ a{color:#505cfe}.HDRdS ._1-qLJ ._1aRAb,.HDRdS ._1-qLJ ._12KTb li a,.HDRdS .pZBxf:before{background:#505cfe}.pZBxf{color:#fff;border:0;outline:none;-webkit-box-shadow:none;box-shadow:none;border-radius:4px;display:inline-block;background:#2a2929;-webkit-transition-delay:.4s;-o-transition-delay:.4s;transition-delay:.4s;@inculude transition}.pZBxf:before{content:\"\";border-radius:4px;background:#43cea2;opacity:.9;-webkit-transition-duration:.4s;-o-transition-duration:.4s;transition-duration:.4s;@inculude transition}._13oDv{background:hsla(0,0%,95%,.3);padding-top:130px}._3Opew{font:600 22px/30px Montserrat,sans-serif;color:#111}.G_83E._1ZZ7O ul li{font-size:14px;padding-bottom:5px}.G_83E._1ZZ7O ul li a,.G_83E._1ZZ7O ul li i{color:#8b8b8b}._263sy{padding-top:65px}._263sy ._28Ely li{display:inline-block}._263sy ._28Ely li ._1HN2V{display:inline-block;height:30px;width:31px;line-height:30px;text-align:center;border:2px solid #8b8b8b;font-size:16px;-webkit-box-sizing:content-box;box-sizing:content-box;font-weight:500;border-radius:50%;color:#8b8b8b;-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._263sy ._28Ely li ._1HN2V:hover{border-color:#000;color:#000}._263sy p{font-size:14px;color:#8b8b8b;padding-top:20px}._263sy p a{color:#000}._2DSLq{font:600 30px/40px Montserrat,sans-serif}._2DSLq small{display:block;color:#999;font-size:18px}._2QhmS._2azlc{font:300 16px/35px Montserrat,sans-serif;color:#999;margin-bottom:0;padding:70px 0 50px}._2QhmS._2azlc a{color:#000;font-weight:400}._1U_Gk .Ouhz3 ._2MVJ7{margin-top:12px}._1U_Gk .Ouhz3 ._2MVJ7 img{width:70%}._1w-O5{color:#212121;background:#8b8b8b;border-radius:5px;padding:0 20px}._1kITw{background:-webkit-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 0);background:-o-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 100%);background:-webkit-gradient(linear,left top,right top,color-stop(100%,rgba(33,33,33,.995)),to(transparent));background:linear-gradient(90deg,rgba(33,33,33,.995) 100%,transparent 0)}._1kITw .Ouhz3{background:transparent}._306ck{background:-webkit-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 0);background:-o-linear-gradient(left,rgba(33,33,33,.995) 100%,transparent 100%);background:-webkit-gradient(linear,left top,right top,color-stop(100%,rgba(33,33,33,.995)),to(transparent));background:linear-gradient(90deg,rgba(33,33,33,.995) 100%,transparent 0)}._306ck .Ouhz3{background:transparent}._306ck .Ouhz3 ._1LA8Y ul li a:hover,._306ck .Ouhz3 ._3-XOQ ._3bh3m .EEVHL ._2_Pft:before{border-color:#827ddc}._306ck ._1-qLJ ._1aRAb{padding-top:19px}._306ck ._1-qLJ ._1aRAb,._306ck .pZBxf:before{background-image:-webkit-linear-gradient(0deg,#ed3d82,#f66164 43%,#fe8545);background-image:-webkit-linear-gradient(0deg,#4d4cad,#827ddc 43%,#9d9dcc);background-image:-ms-linear-gradient(0deg,#4d4cad 0,#827ddc 43%,#9d9dcc 100%)}._306ck ._1-qLJ a{color:#827ddc}._306ck ._1-qLJ ._12KTb li a{background:#f66164}._3BuEt ._3bh3m .EEVHL{float:left}._2OaRp{display:grid;grid-template-columns:1fr 1fr}._3fJMu{display:none}._2A03i{display:block;width:100%;text-align:center;margin-top:55px}._2A03i button{display:inline-block;padding:17px 60px;cursor:pointer;border:0;text-decoration:none;line-height:30px;text-transform:uppercase;font-weight:600;-webkit-box-shadow:0 16px 30px 0 rgba(0,0,0,.12);box-shadow:0 16px 30px 0 rgba(0,0,0,.12);border-radius:45px;background-image:-webkit-linear-gradient(0deg,#4d4cad,#827ddc 43%,#9d9dcc);background-image:-ms-linear-gradient(0deg,#4d4cad 0,#827ddc 43%,#9d9dcc 100%);position:relative;z-index:1;color:#4d4cad}._2A03i button,._2A03i button:before{-webkit-transition:all .3s linear;-o-transition:all .3s linear;transition:all .3s linear}._2A03i button:before{content:\"\";position:absolute;left:0;width:100%;height:100%;top:0;border-radius:45px;background:#fff;z-index:-1}._2A03i button:hover{color:#fff}._2A03i button:hover:before{-webkit-transform:scale(.8);-ms-transform:scale(.8);transform:scale(.8);opacity:0}._1SSsH{display:inline-block;margin:0 5px}._2o-aM{text-align:right}.eueMl{z-index:111111}._1AV9f,.eueMl{position:fixed;top:0;bottom:0;left:0;right:0}._1AV9f{width:100%;height:100%;background-color:#1a1a2470;opacity:0}._2tysq{width:80%;margin:auto;height:auto;position:relative;top:50%;-webkit-transform:translateY(-50%);-ms-transform:translateY(-50%);transform:translateY(-50%);color:#fff;text-align:center;border-radius:5px;overflow:hidden}.c8MWO{opacity:1}._3xFiY{-webkit-animation:_3X2BQ 1s;animation:_3X2BQ 1s}._3Tkt3,._3xFiY{visibility:visible}._3Tkt3{-webkit-animation:ShoCK 1s;animation:ShoCK 1s}.E6NdR{-webkit-animation:_3szu8 1s;animation:_3szu8 1s}@-webkit-keyframes _3X2BQ{0%{bottom:0;opacity:0}to{bottom:40px;opacity:1}}@keyframes _3X2BQ{0%{bottom:0;opacity:0}to{bottom:40px;opacity:1}}@-webkit-keyframes ShoCK{0%{bottom:40px;opacity:1}to{bottom:-40px;opacity:0;visibility:hidden}}@keyframes ShoCK{0%{bottom:40px;opacity:1}to{bottom:-40px;opacity:0;visibility:hidden}}@-webkit-keyframes _3szu8{0%{opacity:0;top:40%}to{opacity:1;top:50%}}@keyframes _3szu8{0%{opacity:0;top:40%}to{opacity:1;top:50%}}@media (max-width:768px){._3MxK6 h2{font-size:30px}._1Tho_ ._1ZQZT ._2BckB h2{font-size:28px;line-height:38px}._1Tho_ ._1ZQZT{padding-top:150px;padding-bottom:100px;height:auto}._1Tho_ ._8Bg-u{margin:33px 0}._1Tho_ ._8Bg-u img{max-width:100%}._3-jA8{padding:0}._3-jA8 h3{font-size:20px}._1jKnt h2{font-size:30px}.w7XFR ._3Xlcm{padding:20px}._1nxjd ._26zha li{margin-bottom:10px}._1MJzy{margin:30px auto 0}._1M6LT,._3c2mN,._26Cka{grid-template-columns:1fr}._1U_Gk .Ouhz3 ._3BuEt{margin:30px auto 0}._1-qLJ{text-align:center}._3fJMu{display:block}._2tysq{width:95%}}._8Ag-N{-ms-flex-pack:justify;justify-content:space-between;max-height:150px;width:80%}._2bxOt,._8Ag-N{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center}._2bxOt{-ms-flex-pack:center;justify-content:center;min-height:100px}._2bxOt button{margin:10px;background:transparent;border:2px solid;color:#4e4dae;padding:10px}._2bxOt button:first-child,._2bxOt button:hover{background:#4e4dae;border:2px solid #4e4dae;color:#fff}._2bxOt button:first-child:hover{background:transparent;border:2px solid;color:#4e4dae}", ""]);

// exports
exports.locals = {
	"btn": "_296Mk",
	"row": "_1MfJf",
	"zi": "_16f3L",
	"myHr": "_3vZkm",
	"bgColorThree": "_3kF8r",
	"sectpad": "_2Jybw",
	"projectsAreaThree": "_2LRuQ",
	"agencyBannerArea": "_1Tho_",
	"agencyBanner": "_1ZQZT",
	"video": "_2jjOy",
	"banerContent": "_2BckB",
	"getBtn": "_1NwlD",
	"devider": "_1afBP",
	"bannerImg": "_8Bg-u",
	"slidersImg": "_16lEt",
	"bubble": "YQ5UI",
	"bubbles": "_3I_bz",
	"moveclouds": "YvFqr",
	"sideWays": "_2QxDU",
	"loader": "_2V-WR",
	"loaderO": "_TsT6",
	"wrapper": "_2P5Bj",
	"squares": "ddYbc",
	"loadSquare": "CaF-K",
	"first-square": "WH8kk",
	"second-square": "_3RBT5",
	"fIconBoxAreaTwo": "FQZvp",
	"fizIconBoxTwo": "_2d-up",
	"fizIconText": "_2u_IQ",
	"fiz_icon_text": "fw-6n",
	"fizIconBox": "DNprC",
	"animatedIcon": "_15QtM",
	"dash": "_2z6TF",
	"arrowRight": "_2Pr23",
	"fizVideoArea": "_28OYM",
	"videoContent": "_3-jA8",
	"videoBtn": "_1XxxQ",
	"btnPlay": "_27d1-",
	"runpulse": "Wvs1H",
	"videoBtnTwo": "Sxuxe",
	"arrowTriangleRight": "_1_PR0",
	"mb60": "_1a2x5",
	"sectionTitleTwo": "-va0n",
	"newServiceArea": "_1PLXZ",
	"serviceFlipbox": "w7XFR",
	"flipboxFont": "_3Xlcm",
	"flipboxBack": "_2bER2",
	"innerFlip": "_1jSfu",
	"serviceFlipboxTwo": "_1xyQz",
	"sectionTitleThree": "_1jKnt",
	"titleGr": "_3olfH",
	"fizTeamArea": "_3oOL5",
	"teamCarousel": "_26Cka",
	"owlStageOuter": "_1_Xau",
	"owlItem": "_3hDRy",
	"owlDots": "_1wDO5",
	"owlDot": "_29QIz",
	"active": "_2pdKw",
	"teamThumbnail": "_2Uqnk",
	"thumbnailRoundImg": "_1Kv6l",
	"callLink": "_3Ch4m",
	"linkGroup": "_32yq6",
	"center": "_3azDT",
	"fizTeamAreaTwo": "dvHjq",
	"linkBlack": "_2Fxxu",
	"recentP": "_3ix14",
	"RecentNewsAreaTwo": "_3k6A1",
	"recent": "_1MJzy",
	"recentTwo": "_2wExH",
	"recentNewsText": "C2e_-",
	"RecentContent": "SHAiw",
	"recentImage": "_110ez",
	"dateHolder": "Cppm_",
	"recentNewsAreaThree": "_2Sf-s",
	"rq-mailform": "fiNJI",
	"group-item": "_2kGpI",
	"formControl": "_3d6ZN",
	"btnBlock": "_2uBAw",
	"requestInfo": "_1k1mw",
	"rqMailform": "sZW4X",
	"groupItem": "_2qeGn",
	"groupItemSm": "_3r09h",
	"brandsArea": "_2ImFS",
	"brandsLogos": "_1M6LT",
	"logo": "rf2Vu",
	"brBg": "_1LzKQ",
	"logoBr": "_3ooGW",
	"clients": "_3TLAE",
	"clientSlider": "_3m6HW",
	"portfolio": "_31JR5",
	"container": "_3YPN-",
	"projectsAreaTwo": "_1nxjd",
	"portfolioFilter": "_26zha",
	"portfolioItems": "_3c2mN",
	"portfolioCol": "_2Sxbu",
	"displayBlock": "_3vxzB",
	"overlay": "_2HtvN",
	"overlayInner": "_2rue4",
	"line": "f9-Tt",
	"footerArea": "_1U_Gk",
	"footerTop": "Ouhz3",
	"widget": "_3BuEt",
	"widgetTitle": "_3c8O_",
	"singleFtWidget": "G_83E",
	"fleft": "_2yL1u",
	"latestWidget": "_1LA8Y",
	"blogWidget": "_3-XOQ",
	"media": "_3bh3m",
	"mediaLeft": "EEVHL",
	"fImage": "_2_Pft",
	"mediaBody": "qdRsD",
	"contactFromWidget": "n5uCL",
	"submitForm": "_1AfRb",
	"message": "_3BPvV",
	"submit": "pZBxf",
	"footerBottom": "_1-qLJ",
	"scrollT": "_1aRAb",
	"nav": "_12KTb",
	"footerAreaTwo": "HDRdS",
	"arFooterArea": "_13oDv",
	"arWidgetTitle": "_3Opew",
	"textWidget": "_1ZZ7O",
	"socialWidget": "_263sy",
	"socialLinks": "_28Ely",
	"circle": "_1HN2V",
	"fLogo": "_2DSLq",
	"small": "_2QhmS",
	"copyright": "_2azlc",
	"brandLogo": "_2MVJ7",
	"formAlert": "_1w-O5",
	"footerAreaThree": "_1kITw",
	"footerAreaFour": "_306ck",
	"bottomRow": "_2OaRp",
	"visibleXs": "_3fJMu",
	"scheduleDemo": "_2A03i",
	"svgSocialIcons": "_1SSsH",
	"right": "_2o-aM",
	"videoModal": "eueMl",
	"modalOverlay": "_1AV9f",
	"modalBody": "_2tysq",
	"showModal": "c8MWO",
	"fadeIn": "_3xFiY",
	"fadein": "_3X2BQ",
	"fadeOut": "_3Tkt3",
	"fadeout": "ShoCK",
	"slideDown": "E6NdR",
	"slideD": "_3szu8",
	"section_title_three": "_3MxK6",
	"clientdiv": "_8Ag-N",
	"buttons": "_2bxOt"
};

/***/ }),

/***/ 750:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(2);
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/components/Layout/Layout.js + 12 modules
var Layout = __webpack_require__(238);

// EXTERNAL MODULE: ./node_modules/isomorphic-style-loader/lib/withStyles.js
var withStyles = __webpack_require__(57);
var withStyles_default = /*#__PURE__*/__webpack_require__.n(withStyles);

// EXTERNAL MODULE: ./node_modules/bootstrap/dist/css/bootstrap.min.css
var bootstrap_min = __webpack_require__(248);
var bootstrap_min_default = /*#__PURE__*/__webpack_require__.n(bootstrap_min);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(77);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/routes/home/img/slide1.png
var slide1 = __webpack_require__(682);
var slide1_default = /*#__PURE__*/__webpack_require__.n(slide1);

// EXTERNAL MODULE: ./src/routes/home/img/slide2.png
var slide2 = __webpack_require__(683);
var slide2_default = /*#__PURE__*/__webpack_require__.n(slide2);

// EXTERNAL MODULE: ./src/routes/home/img/slide3.png
var slide3 = __webpack_require__(684);
var slide3_default = /*#__PURE__*/__webpack_require__.n(slide3);

// EXTERNAL MODULE: ./src/routes/home/img/slide4.png
var slide4 = __webpack_require__(685);
var slide4_default = /*#__PURE__*/__webpack_require__.n(slide4);

// EXTERNAL MODULE: ./src/routes/home/img/slide5.png
var slide5 = __webpack_require__(686);
var slide5_default = /*#__PURE__*/__webpack_require__.n(slide5);

// EXTERNAL MODULE: ./src/routes/home/img/slide6.png
var slide6 = __webpack_require__(687);
var slide6_default = /*#__PURE__*/__webpack_require__.n(slide6);

// EXTERNAL MODULE: ./src/history.js
var src_history = __webpack_require__(40);

// CONCATENATED MODULE: ./src/routes/home/LandingContainer.js
function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }









 // import slide7 from './img/slide7.png';
// import slide8 from './img/slide8.png';
// import slide9 from './img/slide9.png';



var LandingContainer__ref = _jsx("path", {
  fill: "#ffffff",
  d: "M0,24l0.01-0.24V0H240v24c0,0-48.115-23.471-120.039-23.48C48.018,0.52,0,24,0,24L0,24z"
});

var _ref2 = _jsx("h2", {}, void 0, "Drive skills management ", _jsx("br", {}), " and employee learning using AI");

var LandingContainer_LandingContainer =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LandingContainer, _React$Component);

  function LandingContainer() {
    var _this;

    _classCallCheck(this, LandingContainer);

    _this = _possibleConstructorReturn(this, (LandingContainer.__proto__ || Object.getPrototypeOf(LandingContainer)).call(this));
    Object.defineProperty(_assertThisInitialized(_this), "goToScheduleDemo", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        src_history["a" /* default */].push('/demo');
      }
    });
    _this.state = {
      image: [slide1_default.a, slide2_default.a, slide3_default.a, slide4_default.a, slide5_default.a, slide6_default.a],
      active: 0
    };
    return _this;
  }

  _createClass(LandingContainer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var i = 0;
      var intervalId = setInterval(function () {
        i++;

        if (i > _this2.state.image.length - 1) {
          i = 0;
        }

        _this2.setState({
          active: i
        });
      }, 4000);
    }
  }, {
    key: "render",
    value: function render() {
      var s = this.props.styles;
      var slideImage = this.state.image[this.state.active];
      return _jsx("div", {
        id: "top"
      }, void 0, _jsx("section", {
        className: s.agencyBannerArea
      }, void 0, _jsx("div", {
        className: s.agencyBanner
      }, void 0, _jsx("div", {
        className: s.devider
      }, void 0, _jsx("svg", {
        className: classnames_default()(s.uncodeRowDivider, s.uncodeRowDividerCurve),
        x: "0px",
        y: "0px",
        width: "240px",
        height: "24px",
        viewBox: "0 0 240 24",
        enableBackground: "new 0 0 240 24",
        xmlSpace: "preserve",
        preserveAspectRatio: "none"
      }, void 0, LandingContainer__ref)), _jsx("div", {
        className: s.container
      }, void 0, _jsx("div", {
        className: s.banerContent
      }, void 0, _ref2))), _jsx("div", {
        className: s.bannerImg
      }, void 0, _jsx("img", {
        src: slideImage,
        alt: ""
      }))));
    }
  }]);

  return LandingContainer;
}(react_default.a.Component);

/* harmony default export */ var home_LandingContainer = (LandingContainer_LandingContainer);
// EXTERNAL MODULE: ./node_modules/react-visibility-sensor/visibility-sensor.js
var visibility_sensor = __webpack_require__(688);
var visibility_sensor_default = /*#__PURE__*/__webpack_require__.n(visibility_sensor);

// CONCATENATED MODULE: ./src/routes/home/img/icons/LayersAlt.js
var LayersAlt_REACT_ELEMENT_TYPE;

function LayersAlt__jsx(type, props, key, children) { if (!LayersAlt_REACT_ELEMENT_TYPE) { LayersAlt_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: LayersAlt_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function LayersAlt__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { LayersAlt__typeof = function _typeof(obj) { return typeof obj; }; } else { LayersAlt__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return LayersAlt__typeof(obj); }

function LayersAlt__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function LayersAlt__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function LayersAlt__createClass(Constructor, protoProps, staticProps) { if (protoProps) LayersAlt__defineProperties(Constructor.prototype, protoProps); if (staticProps) LayersAlt__defineProperties(Constructor, staticProps); return Constructor; }

function LayersAlt__possibleConstructorReturn(self, call) { if (call && (LayersAlt__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function LayersAlt__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var LayersAlt__ref = LayersAlt__jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  version: "1"
}, void 0, LayersAlt__jsx("path", {
  fill: "none",
  stroke: "#f66164",
  strokeMiterlimit: "10",
  strokeWidth: "2",
  d: "M18 26.066L2 33l30 12 30-12-16-6.933"
}), LayersAlt__jsx("path", {
  fill: "none",
  stroke: "#f66164",
  strokeMiterlimit: "10",
  strokeWidth: "2",
  d: "M18 39.066L2 46l30 12 30-12-16-6.933M32 32l30-12L32 7 2 20z"
}));

var LayersAlt =
/*#__PURE__*/
function (_React$Component) {
  LayersAlt__inherits(LayersAlt, _React$Component);

  function LayersAlt() {
    LayersAlt__classCallCheck(this, LayersAlt);

    return LayersAlt__possibleConstructorReturn(this, (LayersAlt.__proto__ || Object.getPrototypeOf(LayersAlt)).apply(this, arguments));
  }

  LayersAlt__createClass(LayersAlt, [{
    key: "render",
    value: function render() {
      return LayersAlt__ref;
    }
  }]);

  return LayersAlt;
}(react_default.a.Component);

/* harmony default export */ var icons_LayersAlt = (LayersAlt);
// CONCATENATED MODULE: ./src/routes/home/img/icons/PencilRuler.js
var PencilRuler_REACT_ELEMENT_TYPE;

function PencilRuler__jsx(type, props, key, children) { if (!PencilRuler_REACT_ELEMENT_TYPE) { PencilRuler_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: PencilRuler_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function PencilRuler__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { PencilRuler__typeof = function _typeof(obj) { return typeof obj; }; } else { PencilRuler__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return PencilRuler__typeof(obj); }

function PencilRuler__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function PencilRuler__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function PencilRuler__createClass(Constructor, protoProps, staticProps) { if (protoProps) PencilRuler__defineProperties(Constructor.prototype, protoProps); if (staticProps) PencilRuler__defineProperties(Constructor, staticProps); return Constructor; }

function PencilRuler__possibleConstructorReturn(self, call) { if (call && (PencilRuler__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function PencilRuler__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var PencilRuler__ref = PencilRuler__jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64"
}, void 0, PencilRuler__jsx("path", {
  fill: "none",
  stroke: "#f66164",
  strokeMiterlimit: "10",
  strokeWidth: "2",
  d: "M1 63V2l61 61z"
}), PencilRuler__jsx("path", {
  fill: "none",
  stroke: "#f66164",
  strokeMiterlimit: "10",
  strokeWidth: "2",
  d: "M14 54V30l24 24zM8 22H2M6 30H2M8 38H2M6 46H2M8 54H2M25 1l-6 6 36 36 8 2-2-8zM25 13l6-6"
}));

var PencilRuler =
/*#__PURE__*/
function (_React$Component) {
  PencilRuler__inherits(PencilRuler, _React$Component);

  function PencilRuler() {
    PencilRuler__classCallCheck(this, PencilRuler);

    return PencilRuler__possibleConstructorReturn(this, (PencilRuler.__proto__ || Object.getPrototypeOf(PencilRuler)).apply(this, arguments));
  }

  PencilRuler__createClass(PencilRuler, [{
    key: "render",
    value: function render() {
      return PencilRuler__ref;
    }
  }]);

  return PencilRuler;
}(react_default.a.Component);

/* harmony default export */ var icons_PencilRuler = (PencilRuler);
// CONCATENATED MODULE: ./src/routes/home/img/icons/Diamond.js
var Diamond_REACT_ELEMENT_TYPE;

function Diamond__jsx(type, props, key, children) { if (!Diamond_REACT_ELEMENT_TYPE) { Diamond_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Diamond_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Diamond__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Diamond__typeof = function _typeof(obj) { return typeof obj; }; } else { Diamond__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Diamond__typeof(obj); }

function Diamond__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Diamond__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Diamond__createClass(Constructor, protoProps, staticProps) { if (protoProps) Diamond__defineProperties(Constructor.prototype, protoProps); if (staticProps) Diamond__defineProperties(Constructor, staticProps); return Constructor; }

function Diamond__possibleConstructorReturn(self, call) { if (call && (Diamond__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Diamond__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var Diamond__ref = Diamond__jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "64",
  height: "64",
  version: "1"
}, void 0, Diamond__jsx("g", {
  fill: "none",
  stroke: "#f66164",
  strokeMiterlimit: "10",
  strokeWidth: "2"
}, void 0, Diamond__jsx("path", {
  d: "M29 6h17l17 21-31 31L1 27 18 6h14v52"
}), Diamond__jsx("path", {
  d: "M32 57L18 27l6-21M32 57l14-30-6-21M1 27h62"
})));

var Diamond_PencilRuler =
/*#__PURE__*/
function (_React$Component) {
  Diamond__inherits(PencilRuler, _React$Component);

  function PencilRuler() {
    Diamond__classCallCheck(this, PencilRuler);

    return Diamond__possibleConstructorReturn(this, (PencilRuler.__proto__ || Object.getPrototypeOf(PencilRuler)).apply(this, arguments));
  }

  Diamond__createClass(PencilRuler, [{
    key: "render",
    value: function render() {
      return Diamond__ref;
    }
  }]);

  return PencilRuler;
}(react_default.a.Component);

/* harmony default export */ var Diamond = (Diamond_PencilRuler);
// CONCATENATED MODULE: ./src/routes/home/img/icons/RightArrow.js
var RightArrow_REACT_ELEMENT_TYPE;

function RightArrow__jsx(type, props, key, children) { if (!RightArrow_REACT_ELEMENT_TYPE) { RightArrow_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: RightArrow_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function RightArrow__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { RightArrow__typeof = function _typeof(obj) { return typeof obj; }; } else { RightArrow__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return RightArrow__typeof(obj); }

function RightArrow__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function RightArrow__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function RightArrow__createClass(Constructor, protoProps, staticProps) { if (protoProps) RightArrow__defineProperties(Constructor.prototype, protoProps); if (staticProps) RightArrow__defineProperties(Constructor, staticProps); return Constructor; }

function RightArrow__possibleConstructorReturn(self, call) { if (call && (RightArrow__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function RightArrow__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var RightArrow__ref = RightArrow__jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31.49 31.49",
  width: "45px",
  height: "25px"
}, void 0, RightArrow__jsx("path", {
  fill: "#827ddc",
  d: "M21.205 5.007a1.112 1.112 0 0 0-1.587 0 1.12 1.12 0 0 0 0 1.571l8.047 8.047H1.111A1.106 1.106 0 0 0 0 15.737c0 .619.492 1.127 1.111 1.127h26.554l-8.047 8.032c-.429.444-.429 1.159 0 1.587a1.112 1.112 0 0 0 1.587 0l9.952-9.952a1.093 1.093 0 0 0 0-1.571l-9.952-9.953z"
}));

var RightArrow =
/*#__PURE__*/
function (_React$Component) {
  RightArrow__inherits(RightArrow, _React$Component);

  function RightArrow() {
    RightArrow__classCallCheck(this, RightArrow);

    return RightArrow__possibleConstructorReturn(this, (RightArrow.__proto__ || Object.getPrototypeOf(RightArrow)).apply(this, arguments));
  }

  RightArrow__createClass(RightArrow, [{
    key: "render",
    value: function render() {
      return RightArrow__ref;
    }
  }]);

  return RightArrow;
}(react_default.a.Component);

/* harmony default export */ var icons_RightArrow = (RightArrow);
// CONCATENATED MODULE: ./src/routes/home/img/icons/IconOne.js
var IconOne_REACT_ELEMENT_TYPE;

function IconOne__jsx(type, props, key, children) { if (!IconOne_REACT_ELEMENT_TYPE) { IconOne_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: IconOne_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function IconOne__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { IconOne__typeof = function _typeof(obj) { return typeof obj; }; } else { IconOne__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return IconOne__typeof(obj); }

function IconOne__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IconOne__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function IconOne__createClass(Constructor, protoProps, staticProps) { if (protoProps) IconOne__defineProperties(Constructor.prototype, protoProps); if (staticProps) IconOne__defineProperties(Constructor, staticProps); return Constructor; }

function IconOne__possibleConstructorReturn(self, call) { if (call && (IconOne__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function IconOne__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var IconOne__ref = IconOne__jsx("svg", {
  viewBox: "0 0 404 404"
}, void 0, IconOne__jsx("path", {
  fill: "none",
  stroke: "#827ddc",
  strokeWidth: "10",
  d: "M276.8 125.6C264.8 52 235.2.8 200.8.8s-64 51.2-76 125.6C49.6 137.6 0 167.2 0 201.6s51.2 64 125.6 76c12 74.4 40.8 125.6 76 125.6 9.6 0 19.2-4 27.2-10.4 3.2-3.2 4-8 .8-11.2s-8-4-11.2-.8c-4.8 4-10.4 6.4-16.8 7.2-23.2 0-48-41.6-59.2-107.2 19.2 2.4 39.2 3.2 59.2 3.2s39.2-.8 59.2-3.2c-1.6 11.2-4 22.4-7.2 33.6l-10.4-16c-2.4-4-7.2-4.8-11.2-2.4-3.2 2.4-4.8 7.2-2.4 10.4l19.2 31.2.8.8.8.8.8.8.8.8 1.6.8h3.2c.8 0 2.4 0 3.2-.8l36.8-17.6c4-1.6 6.4-6.4 4.8-10.4s-6.4-6.4-10.4-4.8c0 0-.8 0-.8.8l-20 9.6c3.2-12.8 6.4-26.4 8-39.2 74.4-12 125.6-41.6 125.6-76s-52.8-65.6-127.2-77.6zM122.4 260.8C57.6 249.6 16 224.8 16 201.6c0-24.8 44-48 107.2-59.2-4.8 39.2-4.8 79.2-.8 118.4zm140 2.4c-20.8 2.4-40.8 4-61.6 4s-40.8-1.6-61.6-4c-5.6-40.8-5.6-82.4 0-123.2l10.4-.8c4.8-.8 8-4.8 7.2-8.8s-4.8-8-8.8-7.2l-5.6.8c10.4-65.6 35.2-107.2 58.4-107.2s48 41.6 59.2 107.2c-10.4-.8-20-2.4-31.2-2.4l12-12.8c3.2-3.2 3.2-8 0-11.2s-8-3.2-11.2 0L203.2 124l-.8.8s-.8.8-.8 1.6v6.4c0 .8.8.8.8 1.6 0 0 0 .8.8.8l26.4 32c2.4 3.2 7.2 4 11.2 1.6 3.2-2.4 4-7.2 1.6-11.2l-.8-.8-15.2-19.2c12.8.8 24.8 1.6 36 3.2 2.4 20.8 4 40.8 4 61.6 0 20-1.6 40-4 60.8zm16-2.4c2.4-19.2 3.2-39.2 3.2-59.2s-.8-39.2-3.2-59.2c66.4 11.2 107.2 36.8 107.2 59.2s-41.6 48-107.2 59.2z"
}));

var IconOne =
/*#__PURE__*/
function (_React$Component) {
  IconOne__inherits(IconOne, _React$Component);

  function IconOne() {
    IconOne__classCallCheck(this, IconOne);

    return IconOne__possibleConstructorReturn(this, (IconOne.__proto__ || Object.getPrototypeOf(IconOne)).apply(this, arguments));
  }

  IconOne__createClass(IconOne, [{
    key: "render",
    value: function render() {
      return IconOne__ref;
    }
  }]);

  return IconOne;
}(react_default.a.Component);

/* harmony default export */ var icons_IconOne = (IconOne);
// CONCATENATED MODULE: ./src/routes/home/img/icons/IconTwo.js
var IconTwo_REACT_ELEMENT_TYPE;

function IconTwo__jsx(type, props, key, children) { if (!IconTwo_REACT_ELEMENT_TYPE) { IconTwo_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: IconTwo_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function IconTwo__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { IconTwo__typeof = function _typeof(obj) { return typeof obj; }; } else { IconTwo__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return IconTwo__typeof(obj); }

function IconTwo__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IconTwo__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function IconTwo__createClass(Constructor, protoProps, staticProps) { if (protoProps) IconTwo__defineProperties(Constructor.prototype, protoProps); if (staticProps) IconTwo__defineProperties(Constructor, staticProps); return Constructor; }

function IconTwo__possibleConstructorReturn(self, call) { if (call && (IconTwo__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function IconTwo__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var IconTwo__ref = IconTwo__jsx("svg", {
  viewBox: "0 0 480.002 480.002"
}, void 0, IconTwo__jsx("path", {
  fill: "none",
  stroke: "#827ddc",
  strokeWidth: "10",
  d: "M80.006 328.002H16.002a7.998 7.998 0 0 0-8 7.996v136.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V336.002a7.998 7.998 0 0 0-7.996-8zm-8.005 136h-48v-120h48v120zM368.006 264.002h-64.004a7.998 7.998 0 0 0-8 7.996v200.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V272.002a7.998 7.998 0 0 0-7.996-8zm-8.005 200h-48v-184h48v184zM272.006 304.002h-64.004a7.998 7.998 0 0 0-8 7.996v160.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V312.002a7.998 7.998 0 0 0-7.996-8zm-8.005 160h-48v-144h48v144zM176.006 208.002h-64.004a7.998 7.998 0 0 0-8 7.996v256.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996V216.002a7.998 7.998 0 0 0-7.996-8zm-8.005 256h-48v-240h48v240zM464.006 368.002h-64.004a7.998 7.998 0 0 0-8 7.996v96.004a7.998 7.998 0 0 0 7.996 8h64.004a7.998 7.998 0 0 0 8-7.996v-96.004a7.998 7.998 0 0 0-7.996-8zm-8.005 96h-48v-80h48v80z"
}), IconTwo__jsx("path", {
  fill: "none",
  stroke: "#827ddc",
  strokeWidth: "10",
  d: "M478.077 175.371a7.966 7.966 0 0 0-1.751-1.525l-32-20.57a7.997 7.997 0 0 0-12.325 6.726v16h-27.719l-61.625-92.438a8.303 8.303 0 0 0-13.312 0l-87.808 131.711L151.353 4.854a7.887 7.887 0 0 0-7.469-4.852 7.986 7.986 0 0 0-7.324 5.07L34.556 264.002H.001v16h40a7.992 7.992 0 0 0 7.441-5.07l96.871-245.891 88.336 206.109a7.995 7.995 0 0 0 14.008 1.289l89.344-134.016 57.344 86.016a7.994 7.994 0 0 0 6.656 3.562h32v16a7.997 7.997 0 0 0 13.207 6.07l32-27.43a7.991 7.991 0 0 0 .869-11.27zm-30.076 15.241v-15.953l10.637 6.836-10.637 9.117z"
}));

var IconTwo =
/*#__PURE__*/
function (_React$Component) {
  IconTwo__inherits(IconTwo, _React$Component);

  function IconTwo() {
    IconTwo__classCallCheck(this, IconTwo);

    return IconTwo__possibleConstructorReturn(this, (IconTwo.__proto__ || Object.getPrototypeOf(IconTwo)).apply(this, arguments));
  }

  IconTwo__createClass(IconTwo, [{
    key: "render",
    value: function render() {
      return IconTwo__ref;
    }
  }]);

  return IconTwo;
}(react_default.a.Component);

/* harmony default export */ var icons_IconTwo = (IconTwo);
// CONCATENATED MODULE: ./src/routes/home/img/icons/IconThree.js
var IconThree_REACT_ELEMENT_TYPE;

function IconThree__jsx(type, props, key, children) { if (!IconThree_REACT_ELEMENT_TYPE) { IconThree_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: IconThree_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function IconThree__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { IconThree__typeof = function _typeof(obj) { return typeof obj; }; } else { IconThree__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return IconThree__typeof(obj); }

function IconThree__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function IconThree__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function IconThree__createClass(Constructor, protoProps, staticProps) { if (protoProps) IconThree__defineProperties(Constructor.prototype, protoProps); if (staticProps) IconThree__defineProperties(Constructor, staticProps); return Constructor; }

function IconThree__possibleConstructorReturn(self, call) { if (call && (IconThree__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function IconThree__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */


var IconThree__ref = IconThree__jsx("svg", {
  viewBox: "-44 0 511 511.999"
}, void 0, IconThree__jsx("path", {
  fill: "none",
  stroke: "#827ddc",
  strokeWidth: "10",
  d: "M416.82 208.418H296.578c-12.976 0-23.531 10.559-23.531 23.535v72.66h-25.082v-40.597c0-12.977-10.555-23.532-23.531-23.532h-32.485a8.5 8.5 0 0 1-6.601-3.129l-16.73-20.445L302.854 11.605a7.497 7.497 0 0 0-2.171-10.382A7.505 7.505 0 0 0 290.3 3.395l-81.883 125.234-52.148-44.32 34.863-73.598a7.502 7.502 0 0 0-3.57-9.988 7.503 7.503 0 0 0-9.989 3.57l-71.586 151.129-51.875 51.875c-9.176 9.176-9.176 24.101 0 33.277l62.754 62.754c6.45 6.453 14.207 11.113 22.676 13.758a23.358 23.358 0 0 0-2.77 11.059v72.664H24.031C11.055 400.809.5 411.363.5 424.339V504.5c0 4.14 3.36 7.5 7.5 7.5s7.5-3.36 7.5-7.5v-80.16c0-4.707 3.828-8.535 8.531-8.535h120.242c4.141 0 7.5-3.356 7.5-7.496v-80.164c0-4.704 3.829-8.532 8.532-8.532h120.242c4.14 0 7.5-3.36 7.5-7.5v-80.16c0-4.707 3.828-8.531 8.531-8.531H416.82a7.502 7.502 0 0 0 0-15.004zM121.016 158.73l14.214-30.003 46.864 40.168-23.438 35.84zm79.129-17.445l-9.774 14.945-48.484-41.558 7.734-16.328zM156.18 304.613c-10.844 0-21.04-4.222-28.707-11.89l-62.754-62.754c-3.328-3.328-3.328-8.739 0-12.067l7.41-7.406 70.16 70.16a23.381 23.381 0 0 0 16.64 6.895h33.438a7.5 7.5 0 0 0 7.5-7.5c0-4.145-3.355-7.5-7.5-7.5H158.93a8.497 8.497 0 0 1-6.035-2.5l-70.16-70.164 28.917-28.914 62.086 75.882a23.438 23.438 0 0 0 18.211 8.63h32.485c4.703 0 8.53 3.827 8.53 8.53v8.536h-8.534a7.497 7.497 0 0 0-7.5 7.5 7.5 7.5 0 0 0 7.5 7.5h8.535v17.062zm0 0"
}));

var IconThree =
/*#__PURE__*/
function (_React$Component) {
  IconThree__inherits(IconThree, _React$Component);

  function IconThree() {
    IconThree__classCallCheck(this, IconThree);

    return IconThree__possibleConstructorReturn(this, (IconThree.__proto__ || Object.getPrototypeOf(IconThree)).apply(this, arguments));
  }

  IconThree__createClass(IconThree, [{
    key: "render",
    value: function render() {
      return IconThree__ref;
    }
  }]);

  return IconThree;
}(react_default.a.Component);

/* harmony default export */ var icons_IconThree = (IconThree);
// EXTERNAL MODULE: ./node_modules/reactstrap/dist/reactstrap.es.js + 6 modules
var reactstrap_es = __webpack_require__(239);

// CONCATENATED MODULE: ./src/routes/home/Features.js
function Features__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Features__typeof = function _typeof(obj) { return typeof obj; }; } else { Features__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Features__typeof(obj); }

var Features_REACT_ELEMENT_TYPE;

function Features__jsx(type, props, key, children) { if (!Features_REACT_ELEMENT_TYPE) { Features_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Features_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Features__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Features__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Features__createClass(Constructor, protoProps, staticProps) { if (protoProps) Features__defineProperties(Constructor.prototype, protoProps); if (staticProps) Features__defineProperties(Constructor, staticProps); return Constructor; }

function Features__possibleConstructorReturn(self, call) { if (call && (Features__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Features__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */













var Features__ref2 = Features__jsx(icons_IconOne, {});

var _ref3 = Features__jsx("h4", {}, void 0, "360-degree skills benchmarking");

var _ref4 = Features__jsx("p", {}, void 0, "Success profiles are created for all organizational roles \u2013 using insights from the industry and internal data on jobs and performance. Against which you can evaluate employees, create succession plans, create career pathways, maintain a skill inventory, identify mission critical skills ", Features__jsx("br", {}), Features__jsx("br", {}));

var _ref6 = Features__jsx(icons_IconThree, {});

var _ref7 = Features__jsx("h4", {}, void 0, "Hyper-personalised learning pathway");

var _ref8 = Features__jsx("p", {}, void 0, "Content sources -both internal as well as external are scanned to automatically create indexed catalogs. These are dynamic learning content catalogs, accompanied with a content authoring tool to incorporate new content in real time. Various AI techniques are then used to create most relevant and personalised learning plans for individual users. ");

var _ref10 = Features__jsx(icons_IconTwo, {});

var _ref11 = Features__jsx("h4", {}, void 0, "Quantification of learning outcomes");

var _ref12 = Features__jsx("p", {}, void 0, "Connections between business impact, performance metrics and upskilling and learning interventions are established using sophisticated statistical analysis techniques. Performance metrics can be tracked through various internal systems in real time to deliver the effectiveness of learning program and identify their contribution to business outcomes. ");

var Features_Features =
/*#__PURE__*/
function (_React$Component) {
  Features__inherits(Features, _React$Component);

  function Features() {
    Features__classCallCheck(this, Features);

    return Features__possibleConstructorReturn(this, (Features.__proto__ || Object.getPrototypeOf(Features)).apply(this, arguments));
  }

  Features__createClass(Features, [{
    key: "render",
    value: function render() {
      var s = this.props.styles;
      return Features__jsx("div", {
        id: "feature"
      }, void 0, Features__jsx("section", {
        className: classnames_default()(s.fizIconBoxArea, s.fIconBoxAreaTwo)
      }, void 0, Features__jsx(reactstrap_es["b" /* Container */], {}, void 0, Features__jsx(reactstrap_es["d" /* Row */], {}, void 0, Features__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(s.fizIconBox, s.fizIconBoxTwo)
      }, void 0, Features__jsx(visibility_sensor_default.a, {
        intervalDelay: 0,
        partialVisibility: true
      }, void 0, function (_ref) {
        var isVisible = _ref.isVisible;
        return Features__jsx("div", {
          className: classnames_default()(s.animatedIcon, s.colored)
        }, void 0, isVisible && Features__ref2);
      }), Features__jsx("div", {
        className: s.fizIconText
      }, void 0, _ref3, _ref4)), Features__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(s.fizIconBox, s.fizIconBoxTwo)
      }, void 0, Features__jsx(visibility_sensor_default.a, {
        intervalDelay: 0,
        partialVisibility: true
      }, void 0, function (_ref5) {
        var isVisible = _ref5.isVisible;
        return Features__jsx("div", {
          className: classnames_default()(s.animatedIcon, s.colored)
        }, void 0, isVisible && _ref6);
      }), Features__jsx("div", {
        className: s.fizIconText
      }, void 0, _ref7, _ref8)), Features__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: classnames_default()(s.fizIconBox, s.fizIconBoxTwo)
      }, void 0, Features__jsx(visibility_sensor_default.a, {
        intervalDelay: 0,
        partialVisibility: true
      }, void 0, function (_ref9) {
        var isVisible = _ref9.isVisible;
        return Features__jsx("div", {
          className: classnames_default()(s.animatedIcon, s.colored)
        }, void 0, isVisible && _ref10);
      }), Features__jsx("div", {
        className: s.fizIconText
      }, void 0, _ref11, _ref12))))));
    }
  }]);

  return Features;
}(react_default.a.Component);

/* harmony default export */ var home_Features = (Features_Features);
// CONCATENATED MODULE: ./src/routes/home/Video.js
function Video__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Video__typeof = function _typeof(obj) { return typeof obj; }; } else { Video__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Video__typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Video_REACT_ELEMENT_TYPE;

function Video__jsx(type, props, key, children) { if (!Video_REACT_ELEMENT_TYPE) { Video_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Video_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Video__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Video__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Video__createClass(Constructor, protoProps, staticProps) { if (protoProps) Video__defineProperties(Constructor.prototype, protoProps); if (staticProps) Video__defineProperties(Constructor, staticProps); return Constructor; }

function Video__possibleConstructorReturn(self, call) { if (call && (Video__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Video__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function Video__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */





var Video__ref = Video__jsx("h3", {}, void 0, "The only AI-driven learning and organization development platform. ", Video__jsx("span", {}, void 0, "Spotmentor"), " is a platform which combines skill management, learning and development planning and business impact. We use 3 patent-pending ", Video__jsx("span", {}, void 0, "AI algorithms"), " to ensure that you are able to derive real time ROI from your learning efforts.");

var Video_Video =
/*#__PURE__*/
function (_React$Component) {
  Video__inherits(Video, _React$Component);

  function Video() {
    var _this;

    Video__classCallCheck(this, Video);

    _this = Video__possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this));
    Object.defineProperty(Video__assertThisInitialized(_this), "openModal", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          display: true
        });
      }
    });
    Object.defineProperty(Video__assertThisInitialized(_this), "closeModal", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          display: false
        });
      }
    });
    Object.defineProperty(Video__assertThisInitialized(_this), "handleContextMenu", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(e) {
        e.preventDefault();
      }
    });
    _this.state = {
      display: false
    };
    return _this;
  }

  Video__createClass(Video, [{
    key: "render",
    value: function render() {
      var _cx;

      var s = this.props.styles;
      return Video__jsx("div", {
        id: "video"
      }, void 0, Video__jsx("section", {
        className: s.fizVideoArea
      }, void 0, Video__jsx(reactstrap_es["b" /* Container */], {}, void 0, Video__jsx("div", {
        className: s.videoContent
      }, void 0, Video__ref, Video__jsx("a", {
        onClick: this.openModal,
        className: classnames_default()(s.videoBtn, s.videoBtnTwo)
      }, void 0, Video__jsx("span", {
        className: s.btnPlay
      }, void 0, Video__jsx("i", {
        className: s.arrowTriangleRight
      })), "Watch Video"))), this.state.display && Video__jsx("div", {
        className: s.videoModal
      }, void 0, Video__jsx("div", {
        className: classnames_default()(s.modalOverlay, (_cx = {}, _defineProperty(_cx, s.showModal, this.state.display), _defineProperty(_cx, s.fadeIn, this.state.display), _cx)),
        onClick: this.closeModal
      }), Video__jsx("div", {
        className: classnames_default()(s.modalBody, _defineProperty({}, s.slideDown, this.state.display))
      }, void 0, Video__jsx("iframe", {
        className: s.video,
        src: "https://www.youtube.com/embed/iDd0L7zGoYA",
        title: "YouTube video player",
        frameBorder: "0",
        allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
        allowFullScreen: true
      })))));
    }
  }]);

  return Video;
}(react_default.a.Component);

/* harmony default export */ var home_Video = (Video_Video);
// EXTERNAL MODULE: ./src/routes/home/img/new/code.png
var code = __webpack_require__(696);
var code_default = /*#__PURE__*/__webpack_require__.n(code);

// EXTERNAL MODULE: ./src/routes/home/img/new/design.png
var design = __webpack_require__(697);
var design_default = /*#__PURE__*/__webpack_require__.n(design);

// EXTERNAL MODULE: ./src/routes/home/img/new/features.png
var features = __webpack_require__(698);
var features_default = /*#__PURE__*/__webpack_require__.n(features);

// EXTERNAL MODULE: ./src/routes/home/img/new/settings.png
var new_settings = __webpack_require__(699);
var settings_default = /*#__PURE__*/__webpack_require__.n(new_settings);

// EXTERNAL MODULE: ./src/routes/home/img/new/support.png
var support = __webpack_require__(700);
var support_default = /*#__PURE__*/__webpack_require__.n(support);

// EXTERNAL MODULE: ./src/routes/home/img/new/tools.png
var tools = __webpack_require__(701);
var tools_default = /*#__PURE__*/__webpack_require__.n(tools);

// CONCATENATED MODULE: ./src/routes/home/Services.js
function Services__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Services__typeof = function _typeof(obj) { return typeof obj; }; } else { Services__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Services__typeof(obj); }

var Services_REACT_ELEMENT_TYPE;

function Services__jsx(type, props, key, children) { if (!Services_REACT_ELEMENT_TYPE) { Services_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Services_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Services__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Services__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Services__createClass(Constructor, protoProps, staticProps) { if (protoProps) Services__defineProperties(Constructor.prototype, protoProps); if (staticProps) Services__defineProperties(Constructor, staticProps); return Constructor; }

function Services__possibleConstructorReturn(self, call) { if (call && (Services__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Services__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }












var Services__ref = Services__jsx("h2", {}, void 0, "OUR ", Services__jsx("span", {}, void 0, "Solutions"));

var Services__ref2 = Services__jsx("img", {
  src: code_default.a,
  alt: ""
});

var Services__ref3 = Services__jsx("h4", {}, void 0, "Role-wise success profiles");

var Services__ref4 = Services__jsx("p", {}, void 0, "This is the output of Industry Benchmarking activity and gives the technical and Behavioral skill requirements by unique job roles. The uniqueness is that the Spotmentor engine keeps on scanning the evolving skill requirements and updating the dashboard to deliver a Real time benchmarking for all the organizational job roles.");

var Services__ref5 = Services__jsx("img", {
  src: design_default.a,
  alt: ""
});

var Services__ref6 = Services__jsx("h4", {}, void 0, "Emerging skills");

var Services__ref7 = Services__jsx("p", {}, void 0, "This dashboard identifies emerging skills and their impact on the job roles and the employees of the organization and its competitors. This can help in recalibrating job descriptions, reskilling plans and upskilling plans.");

var Services__ref8 = Services__jsx("img", {
  src: features_default.a,
  alt: ""
});

var Services__ref9 = Services__jsx("h4", {}, void 0, "Organisational skill inventory");

var Services__ref10 = Services__jsx("p", {}, void 0, "This dashboard presents the set of all skills and respective proficiencies present in an organization. This also gives an employee-wise view of technical and behavioral skills and respective proficiencies, which are monitored in real time to reflect upskilling too.");

var Services__ref11 = Services__jsx("img", {
  src: settings_default.a,
  alt: ""
});

var Services__ref12 = Services__jsx("h4", {}, void 0, "Indexed catalogs");

var _ref13 = Services__jsx("p", {}, void 0, "Learning content from multiple sources is analyzed and indexed with subjects, keywords and sources. This gives automatically curated, organised and skills-specific content catalogs.");

var _ref14 = Services__jsx("img", {
  src: support_default.a,
  alt: ""
});

var _ref15 = Services__jsx("h4", {}, void 0, "Hyper-personalised learning plans");

var _ref16 = Services__jsx("p", {}, void 0, "The only learning plans which take into account organisation\u2019s needs as well employee attributes to deliver the most targeted and SMART learning plans. These use more than 100 different variables in real time. Some of the variables which are used are role specific skill gaps, emerging skills in the marketplace, employee aspirations, content engagement, peer performance etc.");

var _ref17 = Services__jsx("img", {
  src: tools_default.a,
  alt: ""
});

var _ref18 = Services__jsx("h4", {}, void 0, "Business impact");

var _ref19 = Services__jsx("p", {}, void 0, "A single snapshot that connects important business metrics, employee goals, and learning programs to tell what tangible business improvements are happening due to skilling initiatives. You can use it for strategizing, convincing stakeholders, budgeting etc.");

var Services_Services =
/*#__PURE__*/
function (_React$Component) {
  Services__inherits(Services, _React$Component);

  function Services() {
    Services__classCallCheck(this, Services);

    return Services__possibleConstructorReturn(this, (Services.__proto__ || Object.getPrototypeOf(Services)).apply(this, arguments));
  }

  Services__createClass(Services, [{
    key: "render",
    value: function render() {
      var s = this.props.styles;
      return Services__jsx("div", {
        id: "services"
      }, void 0, Services__jsx("section", {
        className: classnames_default()(s.newServiceArea, s.bgColorThree)
      }, void 0, Services__jsx(reactstrap_es["b" /* Container */], {}, void 0, Services__jsx("div", {
        className: classnames_default()(s.sectionTitleThree, s.titleGr, s.mb60)
      }, void 0, Services__ref), Services__jsx(reactstrap_es["d" /* Row */], {}, void 0, Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref2, Services__ref3)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref4)))), Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref5, Services__ref6)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref7)))), Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref8, Services__ref9)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref10)))), Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, Services__ref11, Services__ref12)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, _ref13)))), Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, _ref14, _ref15)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, _ref16)))), Services__jsx(reactstrap_es["a" /* Col */], {
        md: "4",
        xs: "12",
        className: s.sfb
      }, void 0, Services__jsx("div", {
        className: classnames_default()(s.serviceFlipbox, s.serviceFlipboxTwo)
      }, void 0, Services__jsx("div", {
        className: s.flipboxFont
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, _ref17, _ref18)), Services__jsx("div", {
        className: s.flipboxBack
      }, void 0, Services__jsx("div", {
        className: s.innerFlip
      }, void 0, _ref19))))))));
    }
  }]);

  return Services;
}(react_default.a.Component);

/* harmony default export */ var home_Services = (Services_Services);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(11);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(680);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./src/routes/home/img/team/8b1b68ce.png
var _b1b68ce = __webpack_require__(717);
var _b1b68ce_default = /*#__PURE__*/__webpack_require__.n(_b1b68ce);

// EXTERNAL MODULE: ./src/routes/home/img/team/4b99387b.png
var _b99387b = __webpack_require__(718);
var _b99387b_default = /*#__PURE__*/__webpack_require__.n(_b99387b);

// EXTERNAL MODULE: ./src/routes/home/img/team/f1f8c8a7.png
var f1f8c8a7 = __webpack_require__(719);
var f1f8c8a7_default = /*#__PURE__*/__webpack_require__.n(f1f8c8a7);

// EXTERNAL MODULE: ./src/routes/home/img/team/f660ac03.png
var f660ac03 = __webpack_require__(720);
var f660ac03_default = /*#__PURE__*/__webpack_require__.n(f660ac03);

// EXTERNAL MODULE: ./src/routes/home/img/team/6403252b.jpeg
var _403252b = __webpack_require__(721);
var _403252b_default = /*#__PURE__*/__webpack_require__.n(_403252b);

// CONCATENATED MODULE: ./src/routes/home/Team.js
function Team__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Team__typeof = function _typeof(obj) { return typeof obj; }; } else { Team__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Team__typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Team_REACT_ELEMENT_TYPE;

function Team__jsx(type, props, key, children) { if (!Team_REACT_ELEMENT_TYPE) { Team_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Team_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Team__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Team__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Team__createClass(Constructor, protoProps, staticProps) { if (protoProps) Team__defineProperties(Constructor.prototype, protoProps); if (staticProps) Team__defineProperties(Constructor, staticProps); return Constructor; }

function Team__possibleConstructorReturn(self, call) { if (call && (Team__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Team__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










 // import abhash from './img/team/babbb2b4.png';
// import maniprakash from './img/team/16338d7e.png';

var sliderSettings = {
  dots: true,
  infinite: true,
  autoplay: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [{
    breakpoint: 800,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 1
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }]
};
var teamData = [{
  name: 'Deepak Singh',
  title: 'Co-founder and CEO',
  thumbnail: _b1b68ce_default.a,
  link: 'https://www.linkedin.com/in/deepaksinghkgp/'
}, {
  name: 'Arpit Goyal',
  title: 'Co-founder and CTO',
  thumbnail: f1f8c8a7_default.a,
  link: 'https://www.linkedin.com/in/arpitgoyalkgp/'
}, {
  name: 'Yash Pal Mittal',
  title: 'Co-founder and Machine Learning Head',
  thumbnail: f660ac03_default.a,
  link: 'https://www.linkedin.com/in/yash-pal-mittal-7347945b/'
}, {
  name: 'Shekhar Suman',
  title: 'Co-founder and COO',
  thumbnail: _b99387b_default.a,
  link: 'https://www.linkedin.com/in/shekharsumankgp/'
}, {
  name: 'Gautam Boyanapally',
  title: 'Head - Business Development',
  thumbnail: _403252b_default.a,
  link: 'https://www.linkedin.com/in/gautam-boyanapally-6403252b/'
}];

var Team__ref = Team__jsx("h2", {}, void 0, Team__jsx("span", {}, void 0, "Management"), "Team");

var Team__ref2 = Team__jsx("br", {});

var Team__ref3 = Team__jsx("br", {});

var Team__ref4 = Team__jsx("hr", {});

var Team_Team =
/*#__PURE__*/
function (_React$Component) {
  Team__inherits(Team, _React$Component);

  function Team(props) {
    var _this;

    Team__classCallCheck(this, Team);

    _this = Team__possibleConstructorReturn(this, (Team.__proto__ || Object.getPrototypeOf(Team)).call(this, props));
    _this.state = {
      sliderKey: 'initial'
    };
    return _this;
  }

  Team__createClass(Team, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // this.forceUpdate();
      // console.log(this.slider);
      // this.slider.forceUpdate();
      this.setState({
        sliderKey: 'final'
      });
    }
  }, {
    key: "render",
    value: function render() {
      var s = this.props.styles;
      var sliderKey = this.state.sliderKey;
      return Team__jsx("div", {
        id: "team"
      }, void 0, Team__jsx("section", {
        className: classnames_default()(s.fizTeamArea, s.fizTeamAreaTwo, s.bgColorThree)
      }, void 0, Team__jsx(reactstrap_es["b" /* Container */], {}, void 0, Team__jsx("div", {
        className: classnames_default()(s.sectionTitleThree, s.titleGr, s.mb60)
      }, void 0, Team__ref), Team__jsx("div", {}, void 0, react_default.a.createElement(lib_default.a, _extends({}, sliderSettings, {
        key: sliderKey
      }), teamData.map(function (user) {
        return Team__jsx("div", {
          className: s.teamThumbnail
        }, user.name, Team__jsx("div", {
          className: s.thumbnailRoundImg
        }, void 0, Team__jsx("img", {
          src: user.thumbnail,
          alt: ""
        })), Team__jsx("h4", {}, void 0, user.name), Team__jsx("h6", {}, void 0, user.title, Team__ref2, Team__ref3), Team__ref4, Team__jsx("div", {
          className: s.callLink
        }, void 0, Team__jsx("div", {
          className: s.linkGroup
        }, void 0, Team__jsx("i", {
          className: s.iconMail
        }), Team__jsx("a", {
          className: s.linkBlack,
          href: user.link,
          target: "_blank",
          rel: "noreferrer"
        }, void 0, "LinkedIn Profile"))));
      }))))));
    }
  }]);

  return Team;
}(react_default.a.Component);

/* harmony default export */ var home_Team = (Team_Team);
// EXTERNAL MODULE: ./src/routes/home/img/blog/blog1.jpg
var blog1 = __webpack_require__(722);
var blog1_default = /*#__PURE__*/__webpack_require__.n(blog1);

// EXTERNAL MODULE: ./src/routes/home/img/blog/blog2.jpg
var blog2 = __webpack_require__(723);
var blog2_default = /*#__PURE__*/__webpack_require__.n(blog2);

// EXTERNAL MODULE: ./src/routes/home/img/blog/blog3.jpg
var blog3 = __webpack_require__(724);
var blog3_default = /*#__PURE__*/__webpack_require__.n(blog3);

// EXTERNAL MODULE: ./src/routes/home/img/blog/blog4.jpg
var blog4 = __webpack_require__(725);
var blog4_default = /*#__PURE__*/__webpack_require__.n(blog4);

// CONCATENATED MODULE: ./src/routes/home/News.js
function News__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { News__typeof = function _typeof(obj) { return typeof obj; }; } else { News__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return News__typeof(obj); }

var News_REACT_ELEMENT_TYPE;

function News__jsx(type, props, key, children) { if (!News_REACT_ELEMENT_TYPE) { News_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: News_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function News__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function News__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function News__createClass(Constructor, protoProps, staticProps) { if (protoProps) News__defineProperties(Constructor.prototype, protoProps); if (staticProps) News__defineProperties(Constructor, staticProps); return Constructor; }

function News__possibleConstructorReturn(self, call) { if (call && (News__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function News__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function News__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }











var News__ref2 = News__jsx("h2", {}, void 0, "Awards ", News__jsx("span", {}, void 0, "and"), " Accolades");

var News__ref3 = News__jsx("a", {}, void 0, News__jsx("h4", {}, void 0, "Selected for AWS Activate program for startups"));

var News__ref4 = News__jsx("h6", {}, void 0, "18 August, 2017");

var News__ref5 = News__jsx("a", {}, void 0, News__jsx("h4", {}, void 0, "Selected for IBM Global entrepreneur program"));

var News__ref6 = News__jsx("h6", {}, void 0, "11 August, 2017");

var News__ref7 = News__jsx("a", {}, void 0, News__jsx("h4", {}, void 0, "Oracle Startup Cloud accelerator \u2013 among top 11"));

var News__ref8 = News__jsx("h6", {}, void 0, "4th July, 2018");

var News__ref9 = News__jsx("a", {
  href: "https://www.thehindu.com/news/cities/Delhi/four-iit-kharagpur-alumni-launch-hr-technology-start-up/article24963362.ece?utm_campaign=amp_article_share&utm_medium=referral&utm_source=spotmentor.com",
  target: "_blank"
}, void 0, News__jsx("h4", {}, void 0, "Covered by The Hindu ", News__jsx("br", {}), News__jsx("br", {})));

var News__ref10 = News__jsx("h6", {}, void 0, "17th September, 2018");

var News__ref11 = News__jsx("h2", {}, void 0, News__jsx("span", {}, void 0, "Schedule a"), " demo");

var News_News =
/*#__PURE__*/
function (_React$Component) {
  News__inherits(News, _React$Component);

  function News() {
    var _ref;

    var _temp, _this;

    News__classCallCheck(this, News);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return News__possibleConstructorReturn(_this, (_temp = _this = News__possibleConstructorReturn(this, (_ref = News.__proto__ || Object.getPrototypeOf(News)).call.apply(_ref, [this].concat(args))), Object.defineProperty(News__assertThisInitialized(_this), "goToScheduleDemo", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        return src_history["a" /* default */].push('/demo');
      }
    }), _temp));
  }

  News__createClass(News, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var s = this.props.styles;
      return News__jsx("div", {
        id: "newsHere"
      }, void 0, News__jsx("section", {
        className: classnames_default()(s.row, s.sectpad, s.RecentNewsArea, s.recentNewsAreaThree, s.keyBg)
      }, void 0, News__jsx(reactstrap_es["b" /* Container */], {}, void 0, News__jsx("div", {
        className: classnames_default()(s.sectionTitleThree, s.titleGr, s.mb60)
      }, void 0, News__ref2), News__jsx(reactstrap_es["d" /* Row */], {
        className: s.RecentContent
      }, void 0, News__jsx(reactstrap_es["a" /* Col */], {
        sm: "3",
        xs: "12",
        className: s.newsCols
      }, void 0, News__jsx("div", {
        className: classnames_default()(s.recent, s.recentTwo)
      }, void 0, News__jsx("a", {
        className: s.recentImage
      }, void 0, News__jsx("img", {
        className: s.imgResponsive,
        src: blog1_default.a,
        alt: ""
      })), News__jsx("div", {
        className: s.recentNewsText
      }, void 0, News__ref3, News__ref4))), News__jsx(reactstrap_es["a" /* Col */], {
        sm: "3",
        xs: "12",
        className: s.newsCols
      }, void 0, News__jsx("div", {
        className: classnames_default()(s.recent, s.recentTwo)
      }, void 0, News__jsx("a", {
        className: s.recentImage
      }, void 0, News__jsx("img", {
        className: s.imgResponsive,
        src: blog2_default.a,
        alt: ""
      })), News__jsx("div", {
        className: s.recentNewsText
      }, void 0, News__ref5, News__ref6))), News__jsx(reactstrap_es["a" /* Col */], {
        sm: "3",
        xs: "12",
        className: s.newsCols
      }, void 0, News__jsx("div", {
        className: classnames_default()(s.recent, s.recentTwo)
      }, void 0, News__jsx("a", {
        className: s.recentImage
      }, void 0, News__jsx("img", {
        className: s.imgResponsive,
        src: blog3_default.a,
        alt: ""
      })), News__jsx("div", {
        className: s.recentNewsText
      }, void 0, News__ref7, News__ref8))), News__jsx(reactstrap_es["a" /* Col */], {
        sm: "3",
        xs: "12",
        className: s.newsCols
      }, void 0, News__jsx("div", {
        className: classnames_default()(s.recent, s.recentTwo)
      }, void 0, News__jsx("a", {
        className: s.recentImage,
        href: "https://www.thehindu.com/news/cities/Delhi/four-iit-kharagpur-alumni-launch-hr-technology-start-up/article24963362.ece?utm_campaign=amp_article_share&utm_medium=referral&utm_source=spotmentor.com",
        target: "_blank"
      }, void 0, News__jsx("img", {
        className: s.imgResponsive,
        src: blog4_default.a,
        alt: ""
      })), News__jsx("div", {
        className: s.recentNewsText
      }, void 0, News__ref9, News__ref10)))), News__jsx(reactstrap_es["d" /* Row */], {
        className: s.requestRow
      }, void 0, News__jsx(reactstrap_es["a" /* Col */], {
        md: "12"
      }, void 0, News__jsx("div", {
        className: s.requestInfo
      }, void 0, News__jsx("div", {
        className: classnames_default()(s.sectionTitleThree, s.titleGr)
      }, void 0, News__ref11), News__jsx("p", {
        style: {
          marginTop: '60px',
          padding: '0 50px'
        }
      }, void 0, "Spotmentor is an integrated learning platform which identifies skill gaps, recommends best suited learning content to close those gaps and then tracks the impacts on business goals."), News__jsx("div", {
        style: {
          textAlign: 'center'
        },
        className: s.scheduleDemo
      }, void 0, News__jsx("button", {
        onClick: function onClick() {
          return _this2.goToScheduleDemo('/demo');
        }
      }, void 0, "Schedule Demo"))))))));
    }
  }]);

  return News;
}(react_default.a.Component);

/* harmony default export */ var home_News = (News_News);
// EXTERNAL MODULE: ./src/routes/home/img/partners/image009.jpg
var image009 = __webpack_require__(726);
var image009_default = /*#__PURE__*/__webpack_require__.n(image009);

// EXTERNAL MODULE: ./src/routes/home/img/partners/image010.jpg
var image010 = __webpack_require__(727);
var image010_default = /*#__PURE__*/__webpack_require__.n(image010);

// CONCATENATED MODULE: ./src/routes/home/Partners.js
function Partners__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Partners__typeof = function _typeof(obj) { return typeof obj; }; } else { Partners__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Partners__typeof(obj); }

var Partners_REACT_ELEMENT_TYPE;

function Partners__jsx(type, props, key, children) { if (!Partners_REACT_ELEMENT_TYPE) { Partners_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Partners_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Partners__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Partners__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Partners__createClass(Constructor, protoProps, staticProps) { if (protoProps) Partners__defineProperties(Constructor.prototype, protoProps); if (staticProps) Partners__defineProperties(Constructor, staticProps); return Constructor; }

function Partners__possibleConstructorReturn(self, call) { if (call && (Partners__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Partners__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var Partners__ref = Partners__jsx("h2", {}, void 0, Partners__jsx("span", {}, void 0, "Our"), " Partners");

var Partners__ref2 = Partners__jsx("div", {}, void 0, Partners__jsx("img", {
  src: image009_default.a,
  alt: "img_one"
}));

var Partners__ref3 = Partners__jsx("div", {}, void 0, Partners__jsx("img", {
  src: image010_default.a,
  alt: "img_two"
}));

var Partners_Partners =
/*#__PURE__*/
function (_React$Component) {
  Partners__inherits(Partners, _React$Component);

  function Partners() {
    Partners__classCallCheck(this, Partners);

    return Partners__possibleConstructorReturn(this, (Partners.__proto__ || Object.getPrototypeOf(Partners)).apply(this, arguments));
  }

  Partners__createClass(Partners, [{
    key: "render",
    value: function render() {
      var s = this.props.styles;
      var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [{
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            infinite: true,
            dots: true
          }
        }, {
          breakpoint: 600,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        }, {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }]
      };
      return Partners__jsx("div", {}, void 0, Partners__jsx("section", {
        className: classnames_default()(s.brandsArea, s.brBg, s.keyBg)
      }, void 0, Partners__jsx(reactstrap_es["b" /* Container */], {}, void 0, Partners__jsx("div", {
        className: classnames_default()(s.sectionTitleThree, s.titleGr, s.mb60)
      }, void 0, Partners__ref), Partners__jsx("div", {
        className: s.clientdiv
      }, void 0, Partners__ref2, Partners__ref3))));
    }
  }]);

  return Partners;
}(react_default.a.Component);

/* harmony default export */ var home_Partners = (Partners_Partners);
// EXTERNAL MODULE: ./src/routes/home/Home.css
var home_Home = __webpack_require__(728);
var Home_default = /*#__PURE__*/__webpack_require__.n(home_Home);

// CONCATENATED MODULE: ./src/components/Layout/icon.js
var icon_REACT_ELEMENT_TYPE;

function icon__jsx(type, props, key, children) { if (!icon_REACT_ELEMENT_TYPE) { icon_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: icon_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function icon__extends() { icon__extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return icon__extends.apply(this, arguments); }

 // import * as React from 'react';

var icon__ref = icon__jsx("path", {
  fill: "#b1c0ca",
  d: "M334.512 312h-200a8 8 0 00-5.656 2.344l-96 96 11.312 11.312L137.824 328h187.888c-1.664 9.496-6.888 24-23.2 24h-88v16h88c31.64 0 40-31.4 40-48a8 8 0 00-8-8z"
});

var icon__ref2 = icon__jsx("path", {
  fill: "#b1c0ca",
  d: "M436.168 258.344a8 8 0 00-11.312 0l-72 72 11.312 11.312 65.712-65.712c10.828 14.37 8.629 34.68-5.024 46.4L331.2 416H166.512a8 8 0 00-5.656 2.344l-56 56 11.312 11.312L169.824 432h164.688a8 8 0 005.656-2.344l96-96c29.792-29.792 13.024-62.288 0-75.312zM390.512 112H361.76a111.297 111.297 0 00-8.792-21.192l20.344-20.344a8 8 0 000-11.312L339.36 25.208a8 8 0 00-11.312 0l-20.344 20.344a110.95 110.95 0 00-21.192-8.8V8a8 8 0 00-8-8h-48a8 8 0 00-8 8v28.752a110.95 110.95 0 00-21.192 8.8l-20.344-20.344a8 8 0 00-11.312 0l-33.952 33.944a8 8 0 000 11.312l20.352 20.344a111.392 111.392 0 00-8.8 21.192h-28.752a8 8 0 00-8 8v48a8 8 0 008 8h28.752a111.297 111.297 0 008.792 21.192l-20.344 20.344a8 8 0 000 11.312l33.952 33.952a8.232 8.232 0 0011.312 0l20.344-20.352a111.392 111.392 0 0021.192 8.8V280a8 8 0 008 8h48a8 8 0 008-8v-28.752a111.454 111.454 0 0021.192-8.792l20.344 20.344a8 8 0 0011.312 0l33.944-33.952a8 8 0 000-11.312l-20.344-20.344a111.392 111.392 0 008.8-21.192h28.752a8 8 0 008-8v-48a8 8 0 00-8-8zm-7.999 48h-26.888a8 8 0 00-7.784 6.16 95.729 95.729 0 01-11.68 28.144 8.001 8.001 0 001.152 9.864l19.032 19.024-22.64 22.64-19.024-19.04a8.001 8.001 0 00-9.864-1.152 95.436 95.436 0 01-28.144 11.688 8 8 0 00-6.16 7.784V272h-32v-26.88a8 8 0 00-6.16-7.784 95.436 95.436 0 01-28.144-11.688 8.001 8.001 0 00-9.864 1.152l-19.024 19.04-22.64-22.64 19.032-19.04a8.001 8.001 0 001.152-9.864 95.74 95.74 0 01-11.68-28.144 8 8 0 00-7.784-6.16h-26.888v-32H153.4a8 8 0 007.784-6.16 95.74 95.74 0 0111.68-28.144 8.001 8.001 0 00-1.152-9.864L152.68 64.8l22.632-22.624 19.032 19.032a8.001 8.001 0 009.864 1.152 95.198 95.198 0 0128.144-11.68 8 8 0 006.16-7.784V16h32v26.896a8 8 0 006.168 7.784 95.198 95.198 0 0128.144 11.68 8.001 8.001 0 009.864-1.152l19.024-19.032L356.345 64.8l-19.032 19.032a8.001 8.001 0 00-1.152 9.864 95.74 95.74 0 0111.68 28.144 8 8 0 007.784 6.16h26.888v32z"
});

var icon__ref3 = icon__jsx("path", {
  fill: "#b1c0ca",
  d: "M254.512 96c-26.51 0-48 21.49-48 48s21.491 48 48 48c26.499-.026 47.974-21.501 48-48 0-26.51-21.49-48-48-48zm0 80c-17.673 0-32-14.327-32-32 0-17.673 14.327-32 32-32 17.673 0 32 14.327 32 32 0 17.673-14.327 32-32 32z"
});

function SvgComponent(props) {
  return react["createElement"]("svg", icon__extends({
    viewBox: "0 0 485.656 485.656"
  }, props, {
    width: "400px",
    height: "400px",
    c: true
  }), icon__ref, icon__ref2, icon__ref3);
}

/* harmony default export */ var icon = (SvgComponent); // function SvgComponent(props) {
// 	return (
// 		<svg viewBox="0 0 512 512" width={300} height={300} {...props}>
// 			<circle
// 				cx={256}
// 				cy={256}
// 				r={245}
// 				data-original="#F24976"
// 				className="prefix__active-path"
// 				data-old_color="#F24976"
// 				fill="#4e4dae"
// 			/>
// 			<path
// 				data-original="#445EA0"
// 				fill="#445ea0"
// 				d="M211.24 383.73h89.53v44.43h-89.53z"
// 			/>
// 			<path
// 				data-original="#2E4C89"
// 				fill="#2e4c89"
// 				d="M211.24 383.73h19.842v44.43H211.24z"
// 			/>
// 			<path
// 				d="M345.098 453.795a4.443 4.443 0 01-4.429 4.43H171.331a4.444 4.444 0 01-4.43-4.43v-22.203a4.444 4.444 0 014.43-4.43h169.337a4.443 4.443 0 014.429 4.43v22.203h.001z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M186.744 453.795v-22.203a4.444 4.444 0 014.43-4.43h-19.842a4.444 4.444 0 00-4.43 4.43v22.203a4.444 4.444 0 004.43 4.43h19.842a4.444 4.444 0 01-4.43-4.43z"
// 				data-original="#1A2B63"
// 				fill="#1a2b63"
// 			/>
// 			<path
// 				d="M506.198 42.867H5.803C2.611 42.867 0 45.479 0 48.672v330.254c0 3.191 2.611 5.803 5.803 5.803h344.465v-17.345a3.206 3.206 0 013.203-3.203h13.486c2.754 0 5.62-2.039 6.525-4.641l2.547-6.119c1.198-2.417.621-5.879-1.34-7.821l-9.518-9.443c-.602-.599-.934-1.398-.934-2.251s.332-1.652.935-2.251l17.261-17.126a3.21 3.21 0 012.279-.932c.864 0 1.674.331 2.279.932l9.517 9.443c1.219 1.21 3.102 1.934 5.035 1.934 1.04 0 2.032-.216 2.869-.623l6.201-2.541c2.554-.871 4.598-3.73 4.598-6.487v-13.319a3.205 3.205 0 013.202-3.203h24.439a3.206 3.206 0 013.202 3.203v13.319c0 2.758 2.044 5.616 4.653 6.509l6.207 2.546c.777.381 1.77.596 2.809.596 1.934 0 3.816-.723 5.036-1.933l9.518-9.443c.605-.601 1.414-.932 2.278-.932s1.673.331 2.278.932l17.258 17.127a3.15 3.15 0 01.935 2.251c0 .852-.333 1.652-.935 2.25l-9.515 9.444c-1.961 1.941-2.538 5.403-1.314 7.88l2.542 6.114c.882 2.547 3.747 4.586 6.503 4.586h13.487a3.206 3.206 0 013.203 3.203v14.788c.631-.928 1-2.046 1-3.246V48.672c.003-3.193-2.608-5.805-5.799-5.805z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M25.473 326.701a3.492 3.492 0 003.482 3.482h337.701l15.778-15.655a3.21 3.21 0 012.279-.932c.864 0 1.674.331 2.279.932l9.517 9.443c1.219 1.21 3.102 1.934 5.035 1.934 1.04 0 2.032-.216 2.869-.623l6.201-2.541c2.554-.871 4.598-3.73 4.598-6.487v-13.319a3.205 3.205 0 013.202-3.203h24.439a3.206 3.206 0 013.202 3.203v13.319c0 2.758 2.044 5.616 4.653 6.509l6.207 2.546c.777.381 1.77.596 2.809.596 1.934 0 3.816-.723 5.036-1.933l9.518-9.443c.605-.601 1.414-.932 2.278-.932s1.673.331 2.278.932l7.692 7.634V99.913H25.473v226.788z"
// 				data-original="#FFFFFF"
// 				fill="#fff"
// 			/>
// 			<path
// 				d="M45.315 326.701V99.913H25.473v226.788a3.492 3.492 0 003.482 3.482h19.842a3.491 3.491 0 01-3.482-3.482z"
// 				data-original="#D9EAFC"
// 				fill="#d9eafc"
// 			/>
// 			<path
// 				d="M249.615 253.532c-9.128-9.128-22.482-11.506-33.822-7.15l-38.259-38.259-7.691 7.691a1.002 1.002 0 00-.288.811 8.825 8.825 0 01-1.738 6.265 1 1 0 00-.05 1.138c2.131 3.384 1.903 7.5-.515 10.134l30.38 30.38c-4.357 11.339-1.979 24.695 7.15 33.824 7.902 7.902 19.084 11.038 29.911 8.389a1.601 1.601 0 001.163-1.127c.157-.559 0-1.158-.41-1.567l-19.516-19.518 19.861-19.862 19.517 19.519a1.607 1.607 0 002.694-.756c2.652-10.828-.484-22.009-8.387-29.912zM148.928 208.658c1.713 0 3.415.502 4.924 1.452a1.004 1.004 0 001.138-.05 8.75 8.75 0 015.338-1.784c.309 0 .619.016.927.048a1 1 0 00.81-.288l7.692-7.692-38.259-38.258c4.356-11.34 1.978-24.695-7.15-33.822-7.903-7.903-19.084-11.04-29.911-8.39a1.616 1.616 0 00-1.165 1.128 1.603 1.603 0 00.412 1.567l19.516 19.516-19.862 19.863-19.517-19.518c-.409-.41-1.009-.566-1.567-.41a1.58 1.58 0 00-.702.41 1.596 1.596 0 00-.425.754c-2.65 10.826.487 22.009 8.388 29.91 9.129 9.129 22.483 11.507 33.824 7.151l30.381 30.381c1.38-1.267 3.214-1.968 5.208-1.968z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<circle
// 				cx={256}
// 				cy={357.35}
// 				r={15.667}
// 				data-original="#445EA0"
// 				fill="#445ea0"
// 			/>
// 			<path
// 				d="M483.047 72.461H28.955a3.492 3.492 0 00-3.482 3.482v24.97h461.054v-24.97a3.49 3.49 0 00-3.48-3.482z"
// 				data-original="#5DC1D8"
// 				fill="#5dc1d8"
// 			/>
// 			<path
// 				d="M48.797 72.461H28.955a3.492 3.492 0 00-3.482 3.482v24.97h19.842v-24.97a3.492 3.492 0 013.482-3.482z"
// 				data-original="#28A5A5"
// 				fill="#28a5a5"
// 			/>
// 			<path
// 				d="M414.212 456.022a4.214 4.214 0 004.202 4.202h24.439a4.215 4.215 0 004.202-4.202v-13.318c0-2.311 1.789-4.815 3.977-5.564l6.264-2.566c2.079-1.013 5.121-.508 6.761 1.121l9.518 9.445c1.64 1.626 4.324 1.626 5.965 0l17.258-17.129a4.174 4.174 0 000-5.921l-9.515-9.444c-1.643-1.628-2.146-4.656-1.121-6.729l2.568-6.174c.758-2.183 3.27-3.97 5.58-3.97h13.487a4.213 4.213 0 004.203-4.201v-24.189a4.216 4.216 0 00-4.203-4.203H494.31c-2.311 0-4.822-1.786-5.58-3.97l-2.568-6.174c-1.024-2.072-.522-5.1 1.121-6.727l9.515-9.444a4.174 4.174 0 000-5.921l-17.258-17.127c-1.641-1.629-4.325-1.629-5.965 0l-9.518 9.443c-1.641 1.627-4.684 2.133-6.762 1.121l-6.263-2.566c-2.188-.748-3.977-3.252-3.977-5.563v-13.319a4.215 4.215 0 00-4.202-4.203h-24.439a4.215 4.215 0 00-4.202 4.203v13.319c0 2.311-1.789 4.814-3.977 5.563l-6.261 2.566c-2.076 1.012-5.121.508-6.762-1.121l-9.517-9.443c-1.642-1.629-4.326-1.629-5.967 0l-17.262 17.127a4.178 4.178 0 000 5.921l9.518 9.444c1.642 1.627 2.145 4.654 1.121 6.727l-2.568 6.174c-.76 2.184-3.27 3.97-5.581 3.97H353.47a4.215 4.215 0 00-4.203 4.203v24.189a4.213 4.213 0 004.203 4.201h13.486c2.312 0 4.821 1.787 5.581 3.97l2.569 6.176c1.024 2.07.522 5.099-1.119 6.727l-9.521 9.444a4.178 4.178 0 000 5.921l17.262 17.129c1.641 1.626 4.325 1.626 5.967-.002l9.515-9.443c1.641-1.629 4.684-2.134 6.762-1.122l6.263 2.567c2.188.748 3.977 3.252 3.977 5.564v13.318z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 418.341c-21.628 0-39.16-17.397-39.16-38.861.001-21.466 17.532-38.862 39.16-38.862s39.16 17.397 39.16 38.86c0 21.465-17.532 38.863-39.16 38.863z"
// 				data-original="#FFAF10"
// 				fill="#ffaf10"
// 			/>
// 			<path
// 				d="M403.388 379.479c0-19.456 14.401-35.569 33.202-38.417a39.763 39.763 0 00-5.956-.445c-21.628 0-39.159 17.397-39.16 38.862 0 21.464 17.532 38.861 39.16 38.861 2.025 0 4.015-.152 5.956-.446-18.801-2.848-33.202-18.961-33.202-38.415z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 424.646c-25.069 0-45.464-20.263-45.464-45.166.001-24.905 20.397-45.167 45.464-45.167 25.069 0 45.465 20.262 45.465 45.165 0 24.905-20.396 45.168-45.465 45.168zm0-77.726c-18.115 0-32.854 14.605-32.855 32.56 0 17.952 14.739 32.56 32.855 32.56 18.117 0 32.855-14.607 32.857-32.562 0-17.953-14.74-32.558-32.857-32.558z"
// 				data-original="#DB722C"
// 				fill="#db722c"
// 			/>
// 			<path
// 				d="M430.634 395.908c-9.143 0-16.554-7.357-16.554-16.429 0-9.076 7.411-16.431 16.554-16.431 9.146 0 16.554 7.354 16.554 16.429 0 9.074-7.409 16.431-16.554 16.431z"
// 				data-original="#FFAF10"
// 				fill="#ffaf10"
// 			/>
// 			<path
// 				d="M425.992 379.479c0-6.987 4.401-12.94 10.598-15.315a16.603 16.603 0 00-5.956-1.115c-9.143 0-16.554 7.354-16.554 16.431 0 9.071 7.411 16.429 16.554 16.429 2.103 0 4.106-.406 5.956-1.115-6.196-2.376-10.598-8.328-10.598-15.315z"
// 				data-original="#FF9518"
// 				fill="#ff9518"
// 			/>
// 			<path
// 				d="M430.634 402.211c-12.603 0-22.858-10.197-22.858-22.731 0-12.537 10.255-22.732 22.858-22.732 12.605 0 22.858 10.195 22.858 22.73-.003 12.536-10.255 22.733-22.858 22.733zm0-32.858c-5.652 0-10.249 4.543-10.249 10.126 0 5.58 4.597 10.124 10.249 10.124s10.249-4.544 10.249-10.126c0-5.58-4.597-10.124-10.249-10.124z"
// 				data-original="#DB722C"
// 				fill="#db722c"
// 			/>
// 			<g fill="#445ea0">
// 				<path
// 					d="M140.441 226.608l10.829 10.829a8.939 8.939 0 012.003 3.06l4.692-4.692a9.77 9.77 0 01-3.012-2.051l-10.829-10.828a9.803 9.803 0 01-2.056-3.008l-4.69 4.69a8.93 8.93 0 013.063 2zM252.734 130.761l-5.617-5.617c-.625-.624-1.785-.818-2.578-.432l-12.516 6.108c-.794.387-1.76 1.353-2.146 2.146l-5.565 11.407-62.956 62.956c-2.776-.288-5.633.589-7.779 2.616.719.42 1.396.928 1.997 1.529l10.829 10.828a9.888 9.888 0 011.535 1.992c2.024-2.146 2.899-5 2.612-7.773l62.953-62.953 11.41-5.566c.794-.387 1.76-1.353 2.146-2.146l6.107-12.517c.387-.793.191-1.953-.432-2.578z"
// 					data-original="#445EA0"
// 				/>
// 			</g>
// 			<path
// 				d="M167.749 235.1c-3.538 3.538-9.614 3.251-13.503-.639l-10.829-10.828c-3.889-3.89-4.177-9.966-.639-13.504s9.614-3.251 13.503.639l10.829 10.828c3.889 3.889 4.177 9.965.639 13.504z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<path
// 				d="M430.432 147.983H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.498 7.498 0 01-7.499 7.5zM430.432 172.471H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.499 7.499 0 01-7.499 7.5zM430.432 196.958H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.498 7.498 0 01-7.499 7.5z"
// 				data-original="#69CDFF"
// 				fill="#69cdff"
// 			/>
// 			<g>
// 				<path
// 					d="M430.432 237.979H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.499 7.5zM430.432 262.466H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h131.871c4.143 0 7.5 3.357 7.5 7.5a7.499 7.499 0 01-7.499 7.5zM364.085 286.953H298.56c-4.142 0-7.5-3.357-7.5-7.5s3.358-7.5 7.5-7.5h65.525c4.143 0 7.5 3.357 7.5 7.5s-3.357 7.5-7.5 7.5z"
// 					data-original="#37C47A"
// 					fill="#37c47a"
// 				/>
// 			</g>
// 			<path
// 				d="M105.584 297.266c-3.889 3.89-10.253 3.89-14.143 0l-10.829-10.828c-3.889-3.89-3.889-10.253 0-14.143l46.394-46.393c3.889-3.89 10.253-3.89 14.142 0l10.829 10.829c3.889 3.889 3.889 10.253 0 14.143l-46.393 46.392z"
// 				data-original="#293D7C"
// 				fill="#293d7c"
// 			/>
// 			<g>
// 				<path
// 					d="M97.455 286.438c-3.889-3.89-3.889-10.253 0-14.143l45.043-45.043-1.35-1.351c-3.889-3.89-10.253-3.89-14.142 0l-46.394 46.393c-3.889 3.89-3.889 10.253 0 14.143l10.829 10.828c3.889 3.89 10.253 3.89 14.143 0l1.35-1.35-9.479-9.477zM149.278 216.629c3.538-3.538 9.614-3.251 13.503.639l-6.5-6.5c-3.889-3.89-9.966-4.177-13.503-.639s-3.25 9.614.639 13.504l6.497 6.496c-3.886-3.889-4.172-9.963-.636-13.5z"
// 					data-original="#1A2B63"
// 					fill="#1a2b63"
// 				/>
// 			</g>
// 		</svg>
// 	);
// }
// export default SvgComponent;
// EXTERNAL MODULE: ./src/components/Header/LogoSvgFull.js
var LogoSvgFull = __webpack_require__(249);

// EXTERNAL MODULE: ./src/utils/login.js
var login = __webpack_require__(81);

// CONCATENATED MODULE: ./src/components/Layout/UnderMaintenance.js
function UnderMaintenance__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { UnderMaintenance__typeof = function _typeof(obj) { return typeof obj; }; } else { UnderMaintenance__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return UnderMaintenance__typeof(obj); }

var UnderMaintenance_REACT_ELEMENT_TYPE;

function UnderMaintenance__jsx(type, props, key, children) { if (!UnderMaintenance_REACT_ELEMENT_TYPE) { UnderMaintenance_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: UnderMaintenance_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function UnderMaintenance__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function UnderMaintenance__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function UnderMaintenance__createClass(Constructor, protoProps, staticProps) { if (protoProps) UnderMaintenance__defineProperties(Constructor.prototype, protoProps); if (staticProps) UnderMaintenance__defineProperties(Constructor, staticProps); return Constructor; }

function UnderMaintenance__possibleConstructorReturn(self, call) { if (call && (UnderMaintenance__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function UnderMaintenance__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function UnderMaintenance__assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }







var UnderMaintenance__ref2 = UnderMaintenance__jsx(icon, {});

var UnderMaintenance_UnderMaintenance =
/*#__PURE__*/
function (_React$Component) {
  UnderMaintenance__inherits(UnderMaintenance, _React$Component);

  function UnderMaintenance() {
    var _ref;

    var _temp, _this;

    UnderMaintenance__classCallCheck(this, UnderMaintenance);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return UnderMaintenance__possibleConstructorReturn(_this, (_temp = _this = UnderMaintenance__possibleConstructorReturn(this, (_ref = UnderMaintenance.__proto__ || Object.getPrototypeOf(UnderMaintenance)).call.apply(_ref, [this].concat(args))), Object.defineProperty(UnderMaintenance__assertThisInitialized(_this), "clickSignIn", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        src_history["a" /* default */].push('/sign-in');
      }
    }), Object.defineProperty(UnderMaintenance__assertThisInitialized(_this), "goTo", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value(to) {
        src_history["a" /* default */].push(to);
      }
    }), Object.defineProperty(UnderMaintenance__assertThisInitialized(_this), "handleGoToPlatform", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var user = _this.props.user;
        var redirectUrl = Object(login["a" /* default */])({
          organizationSubdomain: user.subdomain_url,
          websiteHost: window.location.host
        });
        window.location.replace(redirectUrl);
      }
    }), _temp));
  }

  UnderMaintenance__createClass(UnderMaintenance, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          s = _props.styles,
          isLoggedIn = _props.isLoggedIn,
          user = _props.user;
      return UnderMaintenance__jsx("div", {
        style: {
          width: '100vw',
          height: '100vh',
          display: 'flex',
          flexDirection: 'column' // background: '#4e4dae',

        }
      }, void 0, UnderMaintenance__jsx("div", {
        style: {
          display: 'flex',
          flexDirection: 'column',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, void 0, UnderMaintenance__jsx("div", {
        style: {
          display: 'flex',
          width: '400px',
          height: '400px',
          background: 'aliceblue',
          borderRadius: '50%',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, void 0, UnderMaintenance__ref2), UnderMaintenance__jsx("div", {
        style: {
          display: 'flex',
          // flex: 1,
          marginTop: '50px',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }
      }, void 0, UnderMaintenance__jsx("h4", {
        style: {
          fontSize: '40px',
          fontWeight: '800',
          color: '#b1c0ca',
          lineHeight: '60px',
          textAlign: 'center'
        }
      }, void 0, "We are currently under maintenance."), UnderMaintenance__jsx("p", {
        style: {
          fontSize: '22px',
          color: '#b1c0ca',
          textAlign: 'center'
        }
      }, void 0, "We will be back and up soon."), UnderMaintenance__jsx("p", {
        style: {
          fontSize: '22px',
          color: '#4e4dae',
          textAlign: 'center'
        }
      }, void 0, "Our platform is still running."))), UnderMaintenance__jsx("div", {
        className: s.buttons
      }, void 0, !isLoggedIn && UnderMaintenance__jsx("button", {
        onClick: this.clickSignIn
      }, void 0, "Login"), isLoggedIn && user && user.subdomain_url && UnderMaintenance__jsx("button", {
        onClick: this.handleGoToPlatform
      }, void 0, "Go to Platform"), isLoggedIn && UnderMaintenance__jsx("button", {
        onClick: function onClick() {
          return _this2.goTo('/logout');
        }
      }, void 0, UnderMaintenance__jsx("i", {
        className: "fa fa-power-off",
        style: {
          marginRight: '10px'
        }
      }), "Logout")));
    }
  }]);

  return UnderMaintenance;
}(react_default.a.Component);


// CONCATENATED MODULE: ./src/routes/home/Home.js
function Home__typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { Home__typeof = function _typeof(obj) { return typeof obj; }; } else { Home__typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return Home__typeof(obj); }

var Home_REACT_ELEMENT_TYPE;

function Home__jsx(type, props, key, children) { if (!Home_REACT_ELEMENT_TYPE) { Home_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: Home_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

function Home__classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function Home__defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Home__createClass(Constructor, protoProps, staticProps) { if (protoProps) Home__defineProperties(Constructor.prototype, protoProps); if (staticProps) Home__defineProperties(Constructor, staticProps); return Constructor; }

function Home__possibleConstructorReturn(self, call) { if (call && (Home__typeof(call) === "object" || typeof call === "function")) { return call; } if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function Home__inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



 // import Loader from './Loader';




 // import Portfolio from './Portfolio';



 // import Footer from '../homeV2/Footer'




var Home__ref = Home__jsx(home_LandingContainer, {
  styles: Home_default.a
});

var Home__ref2 = Home__jsx(home_Features, {
  styles: Home_default.a
});

var Home__ref3 = Home__jsx(home_Video, {
  styles: Home_default.a
});

var Home__ref4 = Home__jsx(home_Services, {
  styles: Home_default.a
});

var Home_Home =
/*#__PURE__*/
function (_React$Component) {
  Home__inherits(Home, _React$Component);

  function Home() {
    Home__classCallCheck(this, Home);

    return Home__possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).apply(this, arguments));
  }

  Home__createClass(Home, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          underMaintenance = _props.underMaintenance,
          isLoggedIn = _props.isLoggedIn,
          user = _props.user; // if (underMaintenance) {
      //   return (
      //     <UnderMaintenance styles={s} isLoggedIn={isLoggedIn} user={user} />
      //   );
      // }

      return Home__jsx("div", {
        className: Home_default.a.container
      }, void 0, Home__ref, Home__ref2, Home__ref3, Home__ref4, Home__jsx("hr", {
        className: Home_default.a.myHr
      }));
    }
  }]);

  return Home;
}(react_default.a.Component);

/* harmony default export */ var routes_home_Home = (withStyles_default()(bootstrap_min_default.a, Home_default.a)(Home_Home));
// CONCATENATED MODULE: ./src/routes/home/index.js
var home_REACT_ELEMENT_TYPE;

function home__jsx(type, props, key, children) { if (!home_REACT_ELEMENT_TYPE) { home_REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: home_REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }




var title = 'spotmentor - home';

function action(_ref) {
  var query = _ref.query,
      refreshToken = _ref.refreshToken,
      user = _ref.user;
  return {
    chunks: ['homev2'],
    title: title,
    component: home__jsx(Layout["a" /* default */], {}, void 0, home__jsx(routes_home_Home, {
      from: query.from,
      title: title,
      underMaintenance: true,
      isLoggedIn: !!refreshToken,
      user: user
    }))
  };
}

/* harmony default export */ var home = __webpack_exports__["default"] = (action);

/***/ })

});


// WEBPACK FOOTER //
// homev2.460b9fdc.chunk.js